'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var formSchema = require('@graffer-inc/form-schema');
var tslib = require('tslib');
var grafferDesignKit = require('@graffer-inc/graffer-design-kit');
var reactIdGenerator = require('react-id-generator');
var moment = require('moment');
var dateFns = require('date-fns');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var classNames = require('classnames');
var _ = require('lodash-core');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var ___namespace = /*#__PURE__*/_interopNamespace(_);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$6 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.component-module_corporateSearchCloseButton__navsj {\n  position: absolute;\n  top: -5px;\n  right: -10px;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n}\n\n.component-module_corporateSearchCloseButton__navsj:focus {\n  outline: 2px solid #454ab8;\n  border-radius: 4px;\n}\n";
var styles$6 = {"corporateSearchCloseButton":"component-module_corporateSearchCloseButton__navsj"};
styleInject(css_248z$6);

var FormFieldInteractionContext = React__default["default"].createContext({
    setFieldValue: function () {
        throw new Error("setFieldValue must be set by FormFieldInteractionContextProvider");
    },
    setFieldTouched: function () {
        throw new Error("setFieldTouched must be set by FormFieldInteractionContextProvider");
    },
});
var FormFieldInteractionContextProvider = function (_a) {
    var children = _a.children, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched;
    return (React__default["default"].createElement(FormFieldInteractionContext.Provider, { value: {
            setFieldTouched: setFieldTouched,
            setFieldValue: setFieldValue,
        } }, children));
};
var useAutocompleteFieldDispatcher = function () {
    var _a = React__default["default"].useContext(FormFieldInteractionContext), setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched;
    return function (_a) {
        var values = _a.values;
        Object.entries(values).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            // cf. https://github.com/graffer-inc/graffer-schemas/blob/da7cb88cf409e7d12f9b81d700a190c57b623bbe/libs/packages/form-generator/lib/section-template/section-template.tsx#L121-L124
            setFieldTouched(key, true, false);
            setFieldValue(key, value, true);
        });
    };
};

var CorporateSearch = function (_a) {
    var config = _a.config, disabled = _a.disabled, viewMode = _a.viewMode;
    var corporationSearchFormBaseUrl = useExternalServiceUrlConfig().corporationSearchFormBaseUrl;
    var _b = React__default["default"].useState(false), showSearchBox = _b[0], setShowSearchBox = _b[1];
    var toggleExpand = React__default["default"].useCallback(function () {
        setShowSearchBox(!showSearchBox);
    }, [showSearchBox, setShowSearchBox]);
    var ariaControls = React__default["default"].useMemo(function () {
        return "".concat(config.formFieldId, "-search-box");
    }, [config.formFieldId]);
    var dispatcher = useAutocompleteFieldDispatcher();
    var onSelect = React__default["default"].useCallback(function (res) {
        dispatcher({ values: config.mapCorpSearchResToAutocompleteValues(res) });
    }, [config.mapCorpSearchResToAutocompleteValues, dispatcher]);
    var onClose = React__default["default"].useCallback(function () {
        setShowSearchBox(false);
    }, [setShowSearchBox]);
    // 操作不能状態のとき、このコンポーネントを描画する意味はないので
    // 何も表示しない
    if (disabled) {
        return React__default["default"].createElement(React__default["default"].Fragment, null);
    }
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(StartButton, { ariaControls: ariaControls, ariaExpanded: showSearchBox, toggleExpand: 
            // フォームの編集中は機能させる必要がない
            viewMode
                ? function () {
                    return;
                }
                : toggleExpand }),
        React__default["default"].createElement(SearchBox, { componentId: ariaControls, corporateCertsUrl: corporationSearchFormBaseUrl, hidden: !showSearchBox, onSelect: onSelect, onClose: onClose })));
};
var StartButton = function (_a) {
    var ariaControls = _a.ariaControls, ariaExpanded = _a.ariaExpanded, toggleExpand = _a.toggleExpand;
    return (React__default["default"].createElement("p", { style: { margin: "0 0 10px 0" } },
        React__default["default"].createElement(grafferDesignKit.SecondaryButton, { text: "法人を検索して自動入力する", onClick: toggleExpand, isSmall: true, icon: "SearchIcon", "aria-expanded": ariaExpanded, "aria-controls": ariaControls })));
};
var SearchBox = function (_a) {
    var componentId = _a.componentId, corporateCertsUrl = _a.corporateCertsUrl, hidden = _a.hidden, onSelect = _a.onSelect, onClose = _a.onClose;
    return (React__default["default"].createElement("div", { id: componentId, style: {
            backgroundColor: "white",
            border: "1px solid #CFCFCF",
            borderRadius: "3px",
            padding: "12px",
            margin: "10px 0 20px 0",
            position: "relative",
            display: hidden ? "none" : undefined,
        } },
        React__default["default"].createElement("button", { onClick: onClose, className: styles$6.corporateSearchCloseButton, "aria-label": "\u9589\u3058\u308B" },
            React__default["default"].createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
                React__default["default"].createElement("g", { clipPath: "url(#clip0_1149_3379)" },
                    React__default["default"].createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#1D1C1A" }),
                    React__default["default"].createElement("path", { d: "M17.8678 7.40396L16.5958 6.13196L11.9998 10.728L7.40384 6.13196L6.13184 7.40396L10.7278 12L6.13184 16.596L7.40384 17.868L11.9998 13.272L16.5958 17.868L17.8678 16.596L13.2718 12L17.8678 7.40396Z", fill: "white" })),
                React__default["default"].createElement("defs", null,
                    React__default["default"].createElement("clipPath", { id: "clip0_1149_3379" },
                        React__default["default"].createElement("rect", { width: "24", height: "24", fill: "white" }))))),
        React__default["default"].createElement(grafferDesignKit.CorporationSearchForm, { initKeyword: "", onSelect: function (res) {
                onSelect(res);
                onClose();
            }, baseUrl: corporateCertsUrl })));
};

var defaultCorporationSearchFormBaseUrl = "/corporate-certs/v1/corporations";

var defaultAddressSearchBaseUrl = "/address/v3/search";

var defaultFormSubmissionContext = function () {
    return {
        submissionDate: new Date(),
    };
};
var defaultExternalServiceUrlConfig = {
    corporationSearchFormBaseUrl: defaultCorporationSearchFormBaseUrl,
    addressSearchBaseUrl: defaultAddressSearchBaseUrl,
};
var defaultMarkdownConfig = {
    markdownProcessor: function () {
        console.log("default markdown processor does not process markdown");
        return null;
    },
};
var FormContext = React__namespace.createContext({
    refKeyContext: {},
    confirmContext: {},
    modificationContext: {},
    submissionContext: defaultFormSubmissionContext(),
});
function useRepeatableExpand() {
    var enableRepeatableExpand = React.useContext(FormContext).enableRepeatableExpand;
    return !!enableRepeatableExpand;
}
var useConditionalCallback = function (callback, deps) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useCallback(callback || (function () { return undefined; }), deps);
};
function useFileRefKeyExchangerIfProvided() {
    var fileRefKeyExchanger = React.useContext(FormContext).refKeyContext.fileRefKeyExchanger;
    var refkeyToValue = useConditionalCallback(fileRefKeyExchanger === null || fileRefKeyExchanger === void 0 ? void 0 : fileRefKeyExchanger.refkeyToValue.bind(fileRefKeyExchanger), [fileRefKeyExchanger]);
    var valueToRefKey = useConditionalCallback(fileRefKeyExchanger === null || fileRefKeyExchanger === void 0 ? void 0 : fileRefKeyExchanger.valueToRefkey.bind(fileRefKeyExchanger), [fileRefKeyExchanger]);
    var clearRefKey = useConditionalCallback(fileRefKeyExchanger === null || fileRefKeyExchanger === void 0 ? void 0 : fileRefKeyExchanger.clearRefKey.bind(fileRefKeyExchanger), [fileRefKeyExchanger]);
    if (!fileRefKeyExchanger) {
        return {};
    }
    return {
        refkeyToValue: refkeyToValue,
        valueToRefKey: valueToRefKey,
        clearRefKey: clearRefKey,
    };
}
function useFileRefKeyExchanger() {
    var callbacks = useFileRefKeyExchangerIfProvided();
    if (Object.keys(callbacks).length === 0) {
        throw new Error("fileRefKeyExchanger must be provided for file input.");
    }
    return {
        refkeyToValue: callbacks.refkeyToValue,
        valueToRefKey: callbacks.valueToRefKey,
        clearRefKey: callbacks.clearRefKey,
    };
}
function useMyNumberRefKeyExchangerIfProvided() {
    var myNumberRefKeyExchanger = React.useContext(FormContext).refKeyContext.myNumberRefKeyExchanger;
    var refkeyToValue = useConditionalCallback(myNumberRefKeyExchanger === null || myNumberRefKeyExchanger === void 0 ? void 0 : myNumberRefKeyExchanger.refkeyToValue.bind(myNumberRefKeyExchanger), [myNumberRefKeyExchanger]);
    var valueToRefKey = useConditionalCallback(myNumberRefKeyExchanger === null || myNumberRefKeyExchanger === void 0 ? void 0 : myNumberRefKeyExchanger.valueToRefkey.bind(myNumberRefKeyExchanger), [myNumberRefKeyExchanger]);
    var clearRefKey = useConditionalCallback(myNumberRefKeyExchanger === null || myNumberRefKeyExchanger === void 0 ? void 0 : myNumberRefKeyExchanger.clearRefKey.bind(myNumberRefKeyExchanger), [myNumberRefKeyExchanger]);
    if (!myNumberRefKeyExchanger) {
        return {};
    }
    return {
        refkeyToValue: refkeyToValue,
        valueToRefKey: valueToRefKey,
        clearRefKey: clearRefKey,
    };
}
function useMyNumberRefKeyExchanger() {
    var callbacks = useMyNumberRefKeyExchangerIfProvided();
    if (Object.keys(callbacks).length === 0) {
        throw new Error("fileRefKeyExchanger must be provided for file input.");
    }
    return {
        refkeyToValue: callbacks.refkeyToValue,
        valueToRefKey: callbacks.valueToRefKey,
        clearRefKey: callbacks.clearRefKey,
    };
}
function useImageRefkeyExchanger() {
    var refKeyContext = React.useContext(FormContext).refKeyContext;
    var imageRefkeyExchanger = refKeyContext.imageRefkeyExchanger;
    if (!imageRefkeyExchanger) {
        throw new Error("imageRefKeyExchanger must be provided for image element.");
    }
    return imageRefkeyExchanger;
}
var useFormSubmissionContext = function () {
    var submissionContext = React.useContext(FormContext).submissionContext;
    return submissionContext;
};
var useExternalServiceUrlConfig = function () {
    var externalServiceUrlConfig = React.useContext(FormContext).externalServiceUrlConfig;
    return externalServiceUrlConfig !== null && externalServiceUrlConfig !== void 0 ? externalServiceUrlConfig : defaultExternalServiceUrlConfig;
};
function useMarkdownConfig() {
    var markdownConfig = React.useContext(FormContext).markdownConfig;
    return markdownConfig !== null && markdownConfig !== void 0 ? markdownConfig : defaultMarkdownConfig;
}

function useRepeatable(length) {
    var _a = React.useState(formSchema.StringGenerator.generateUniqueIDs(length)), repeatableKeys = _a[0], setKeys = _a[1];
    // unit（1件の繰り返しのまとまりの単位）を追加した時に、フォーカスするべきunitのindexを保持しておく
    // この値を参照し、RepeatableUnit / ConfirmRepeatableUnit コンポーネントでフォーカスを当てる。
    var _b = React.useState(undefined), focusUnitIndex = _b[0], setFocusUnitIndex = _b[1];
    return {
        repeatableKeys: repeatableKeys,
        focusUnitIndex: focusUnitIndex,
        onDelete: function (idx) {
            var deleted = repeatableKeys.filter(function (_, i) { return idx !== i; });
            setKeys(deleted);
        },
        onInsert: function (idx) {
            // unit追加時には、追加したunitのindexを保持しておく
            setFocusUnitIndex(repeatableKeys.length === 0 ? 0 : idx + 1);
            setKeys(tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray([], repeatableKeys.slice(0, idx + 1), true), [
                formSchema.StringGenerator.generateUnique(repeatableKeys)
            ], false), repeatableKeys.slice(idx + 1), true));
        },
        onResetFocusUnitIndex: function () {
            // フォーカスするべきunitのindexをリセットする
            setFocusUnitIndex(undefined);
        },
    };
}

function isString(v) {
    return typeof v === "string" || v instanceof String;
}
var Repeatable = function (_a) {
    var config = _a.config, errors = _a.errors, values = _a.values, touched = _a.touched, onFocus = _a.onFocus, onChange = _a.onChange, onBlur = _a.onBlur, disabled = _a.disabled, applyingRules = _a.applyingRules, FieldTemplateRegistry = _a.FieldTemplateRegistry, InputElementRegistry = _a.InputElementRegistry, RepeatableElementRegistry = _a.RepeatableElementRegistry, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched, setTouched = _a.setTouched;
    var enableExpand = useRepeatableExpand();
    var renderValues = config.renderValues(values);
    var _b = React.useState(new Array(config.maxLength).fill(false).map(function (_, idx) {
        return renderValues.length > 0 && idx === 0;
    })), expandState = _b[0], setExpandState = _b[1];
    var _c = useRepeatable(renderValues.length), repeatableKeys = _c.repeatableKeys, onDeleteRepetableKeys = _c.onDelete, onInsert = _c.onInsert, focusUnitIndex = _c.focusUnitIndex, onResetFocusUnitIndex = _c.onResetFocusUnitIndex;
    var fileRefKey = useFileRefKeyExchangerIfProvided();
    var myNumberRefKey = useMyNumberRefKeyExchangerIfProvided();
    var RepeatableComponent = RepeatableElementRegistry.get(config);
    var RepeatableUnitComponent = RepeatableElementRegistry.getUnit(config);
    var detector = React__namespace.useContext(FormContext).modificationContext.detector;
    var diff = (detector === null || detector === void 0 ? void 0 : detector.checkRepeatable(config)) || [];
    var isCopyable = React.useMemo(function () { return config.canCopy(renderValues); }, [renderValues, config]);
    return (React__namespace.createElement(RepeatableComponent, { config: config, values: values, onAdd: function () {
            onInsert(renderValues.length);
            setFieldValue(config.id, tslib.__spreadArray(tslib.__spreadArray([], renderValues, true), [config.toUnitInitialValue()], false), true);
        }, disabled: disabled, isAddDisabled: !!config.maxLength && renderValues.length === config.maxLength },
        renderValues.map(function (unitValue, elemIndex) {
            var unitError = errors && !isString(errors) && errors.length > elemIndex
                ? errors[elemIndex] || {}
                : {};
            var unitTouched = touched && touched.length > elemIndex
                ? touched[elemIndex] || {}
                : {};
            var onDeleteUnit = function () {
                for (var _i = 0, _a = config.unitAtIndex(elemIndex); _i < _a.length; _i++) {
                    var elem = _a[_i];
                    if (unitValue[elem.id]) {
                        if (formSchema.isMyNumberClassInputElement(elem)) {
                            myNumberRefKey.clearRefKey(unitValue[elem.id]);
                        }
                        if (formSchema.isFileInputClassElement(elem)) {
                            fileRefKey.clearRefKey(unitValue[elem.id]);
                        }
                    }
                }
                onDeleteRepetableKeys(elemIndex);
                setTouched(touched === null || touched === void 0 ? void 0 : touched.filter(function (_, idx) { return idx !== elemIndex; }));
                setFieldValue(config.id, !config.required && (values === null || values === void 0 ? void 0 : values.length) === 1
                    ? undefined
                    : renderValues.filter(function (_, index) { return index !== elemIndex; }), true);
            };
            var componentKey = repeatableKeys[elemIndex];
            var appliedConfig = config.applyRules(applyingRules, elemIndex);
            var onCopyValues = function (index, value) {
                if (isCopyable) {
                    onInsert(index);
                    if (touched) {
                        setTouched(tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray([], touched.slice(0, index + 1), true), [
                            {}
                        ], false), touched.slice(index + 1), true));
                    }
                    setFieldValue(config.id, tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray([], renderValues.slice(0, index + 1), true), [
                        config.toCopiedUnitValue(value)
                    ], false), renderValues.slice(index + 1), true), true);
                }
            };
            var onAdd = function (index) {
                onInsert(index);
                if (touched) {
                    setTouched(tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray([], touched.slice(0, index + 1), true), [
                        {}
                    ], false), touched.slice(index + 1), true));
                }
                setFieldValue(config.id, tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray([], renderValues.slice(0, index + 1), true), [
                    config.toUnitInitialValue()
                ], false), renderValues.slice(index + 1), true), true);
            };
            return (React__namespace.createElement(RepeatableUnitComponent, { key: componentKey, index: elemIndex, config: appliedConfig, disabled: disabled, isExpanded: expandState[elemIndex], onToggle: enableExpand
                    ? function () {
                        setExpandState(expandState.map(function (v, idx) {
                            return idx === elemIndex ? !v : v;
                        }));
                    }
                    : undefined, error: isString(unitError) ? unitError : undefined, onDelete: appliedConfig.minLength - 1 < elemIndex ||
                    !appliedConfig.required
                    ? onDeleteUnit
                    : undefined, isCopyable: isCopyable, isAddDisabled: !!appliedConfig.maxLength &&
                    renderValues.length === appliedConfig.maxLength, onCopyValues: function () { return onCopyValues(elemIndex, unitValue); }, onAdd: function () { return onAdd(elemIndex); }, focusUnitIndex: focusUnitIndex, resetFocusUnitIndex: onResetFocusUnitIndex }, appliedConfig
                .unitAtIndex(elemIndex)
                .map(function (elem) {
                var FieldTemplate = FieldTemplateRegistry.get(elem, appliedConfig);
                var unitInnerError = !isString(unitError)
                    ? unitError
                    : {};
                if (formSchema.isInputElement(elem)) {
                    if (elem.hidden) {
                        return null;
                    }
                    var Input = InputElementRegistry.get(elem, config);
                    var value = unitValue[elem.id];
                    var error = unitInnerError[elem.id];
                    var touched_1 = unitTouched[elem.id];
                    var setValue_1 = function (v) {
                        setFieldTouched(elem.formFieldId, true);
                        setFieldValue(elem.formFieldId, v, true);
                    };
                    return (React__namespace.createElement(FieldTemplate, { key: "".concat(componentKey, "_").concat(elem.formFieldId), config: elem, error: error, touched: touched_1, disabled: disabled },
                        React__namespace.createElement(Input, { config: elem, value: value, onBlur: onBlur, onChange: onChange, onFocus: onFocus, error: error, touched: touched_1, setValue: setValue_1, disabled: disabled })));
                }
            })));
        }),
        diff.map(function (d, i) {
            return d === "REMOVED" ? (React__namespace.createElement("div", { className: "field", key: i },
                React__namespace.createElement("p", null, "".concat(config.label.text, " # ").concat(i + 1, " "),
                    React__namespace.createElement(grafferDesignKit.GrafferSchemasTags, { tags: [
                            {
                                color: "warn",
                                label: "訂正",
                            },
                        ] })))) : (React__namespace.createElement(React__namespace.Fragment, { key: i }));
        })));
};

var css_248z$5 = ".index-module_errorContent__g3g57 {\n  color: #de3226;\n}\n";
var styles$5 = {"errorContent":"index-module_errorContent__g3g57"};
styleInject(css_248z$5);

// GCDKのMarkdownEditor側で定義しているが、GCDKとGDKの同時参照やFormBuilderとの循環参照を避けるため二重管理する
var allTagNames = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "a",
    "ul",
    "ol",
    "li",
    "p",
    "strong",
];
// 以下、GrafferSchemasの責務でもつもの
var grafferSchemasSuportTagNames = [
    "p",
    "strong",
    "a",
    "ul",
    "ol",
    "li",
];

var MarkdownErrorHandler = function (_a) {
    var value = _a.value, markdownProcessor = _a.markdownProcessor;
    var _b = React__namespace.useState(null), error = _b[0], setError = _b[1];
    var _c = React__namespace.useState(null), content = _c[0], setContent = _c[1];
    React__namespace.useEffect(function () {
        if (value === "") {
            setContent(null);
            setError(null);
            return;
        }
        try {
            var result = markdownProcessor(value, grafferSchemasSuportTagNames);
            setContent(result);
            setError(null);
        }
        catch (e) {
            setError(e instanceof Error ? e : new Error(String(e)));
            setContent(null);
        }
    }, [value, markdownProcessor]);
    if (value === "") {
        return React__namespace.createElement(React__namespace.Fragment, null);
    }
    if (error) {
        return (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement("p", { className: styles$5.errorContent }, "\u203B\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u8868\u793A\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u305F\u305F\u3081\u3001\u30B9\u30BF\u30A4\u30EB\u304C\u5D29\u308C\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"),
            React__namespace.createElement("p", null, value)));
    }
    return React__namespace.createElement(React__namespace.Fragment, null, content);
};

var Field = function (_a) {
    var config = _a.config, error = _a.error, touched = _a.touched, children = _a.children, readonly = _a.readonly, displayAutoSetTag = _a.displayAutoSetTag, helperTextProps = _a.helperTextProps;
    var markdownProcessor = useMarkdownConfig().markdownProcessor;
    var title = config.label.shouldDisplay ? config.label.text : "";
    var descriptionPlain = config.description.shouldDisplay && !config.description.isMarkdown
        ? config.description.text
        : "";
    var descriptionMarkdown = config.description.shouldDisplay && !!config.description.isMarkdown
        ? config.description.text
        : "";
    var id = config.formFieldId;
    var descriptionId = "schemas-description-id-".concat(config.formFieldId);
    var errorMessageId = React__namespace.useMemo(function () {
        return touched && error ? "schemas-error-message-id-".concat(config.formFieldId) : "";
    }, [config.formFieldId, touched, error]);
    var tags = React__namespace.useMemo(function () {
        return [
            {
                required: !!config.required,
                hidden: !config.label.shouldDisplay ||
                    !!readonly ||
                    config.inputType === "formula_result",
            },
            {
                color: "default",
                label: "自動計算",
                hidden: !config.label.shouldDisplay || config.inputType !== "formula_result",
            },
            {
                color: "default",
                label: "自動入力",
                hidden: !config.label.shouldDisplay || !readonly || !displayAutoSetTag,
            },
        ];
    }, [config, readonly, displayAutoSetTag]);
    return formSchema.needFieldsetWrapInputElement(config) ? (React__namespace.createElement(grafferDesignKit.GrafferSchemasContextProvider, { id: id, descriptionId: descriptionId, errorMessageId: errorMessageId },
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement(grafferDesignKit.GrafferSchemasFieldsetWrap, { title: title, description: descriptionMarkdown ? (React__namespace.createElement(MarkdownErrorHandler, { value: descriptionMarkdown, markdownProcessor: markdownProcessor })) : (descriptionPlain), tags: tags },
                React__namespace.createElement("div", { className: "control" }, children),
                touched && error && React__namespace.createElement(grafferDesignKit.GrafferSchemasErrorMessages, { messages: error }))))) : (React__namespace.createElement(grafferDesignKit.GrafferSchemasContextProvider, { id: id, descriptionId: descriptionId, errorMessageId: errorMessageId },
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement(grafferDesignKit.GrafferSchemasTitleWrap, { title: title, id: config.formFieldId, description: descriptionMarkdown ? (React__namespace.createElement(MarkdownErrorHandler, { value: descriptionMarkdown, markdownProcessor: markdownProcessor })) : (descriptionPlain), tags: tags }),
            React__namespace.createElement("div", { className: "control" }, children),
            touched && error && React__namespace.createElement(grafferDesignKit.GrafferSchemasErrorMessages, { messages: error }),
            helperTextProps && React__namespace.createElement(grafferDesignKit.HelperText, tslib.__assign({}, helperTextProps)))));
};
var FieldReadonlyTemplate = function (displayAutoSetTag) {
    return function (props) {
        return React__namespace.createElement(Field, tslib.__assign({}, props, { readonly: true, displayAutoSetTag: displayAutoSetTag }));
    };
};

var FieldTemplate = /** @class */ (function () {
    function FieldTemplate() {
    }
    FieldTemplate.prototype.get = function (_elem, _repeatable) {
        return Field;
    };
    FieldTemplate.prototype.getReadOnly = function (optionals) {
        return FieldReadonlyTemplate(!!(optionals === null || optionals === void 0 ? void 0 : optionals.displayAutoSetTags));
    };
    return FieldTemplate;
}());
var DefaultTemplateRegistry = new FieldTemplate();

var ConfirmFieldTemplate = function (_a) {
    var config = _a.config, error = _a.error, touched = _a.touched, disabled = _a.disabled, readonly = _a.readonly, displayAutoSetTag = _a.displayAutoSetTag, children = _a.children;
    var editButtonRef = React.useRef(null);
    var confirmButtonRef = React.useRef(null);
    var _b = React.useContext(FormContext), _c = _b.confirmContext, onEdit = _c.onEdit, editIds = _c.editIds, lastClickedButtonFieldId = _c.lastClickedButtonFieldId, detector = _b.modificationContext.detector;
    var generatedId = reactIdGenerator.useId(1, "".concat(config.formFieldId, "-"))[0];
    var confirmFieldId = "confirm-field-".concat(generatedId);
    var focusGetableAreaId = "focus-getable-area-".concat(generatedId);
    var isEditing = React.useMemo(function () { return editIds === null || editIds === void 0 ? void 0 : editIds.includes(config.formFieldId); }, [editIds, config.formFieldId]);
    // フォーカスに関する処理
    React.useEffect(function () {
        // 最後に「編集」もしくは「完了する」ボタンが押されたフィールド以外は何もしない。
        if (lastClickedButtonFieldId !== config.formFieldId) {
            return;
        }
        // 編集完了後は、「編集」ボタンにフォーカスを当てる。
        if (!isEditing) {
            if (editButtonRef.current) {
                editButtonRef.current.focus();
            }
        }
        else {
            // 「編集」ボタン押下後、入力要素にフォーカスを当てる。（無い場合は「完了する」ボタン）
            var focusGetableDiv = document.getElementById(focusGetableAreaId);
            if (focusGetableDiv) {
                var focusableElements = focusGetableDiv.querySelectorAll("input, textarea, select, button");
                if (focusableElements.length > 0) {
                    // いちばん最初のフォーカス可能要素にフォーカスを当てる。
                    focusableElements[0].focus();
                    return;
                }
            }
            // 「完了する」ボタンにフォーカスを当てる。
            if (confirmButtonRef.current) {
                confirmButtonRef.current.focus();
                return;
            }
        }
    }, [
        lastClickedButtonFieldId,
        config.formFieldId,
        isEditing,
        focusGetableAreaId,
    ]);
    // 確認モードでエラーが発生した場合、編集モードに切り替える。
    React.useEffect(function () {
        if (!isEditing && error) {
            if (onEdit !== undefined) {
                onEdit(config, true, false);
            }
        }
    }, [onEdit, isEditing, config, error]);
    var diffType = detector === null || detector === void 0 ? void 0 : detector.checkInput(config);
    var isFormulaResult = config.inputType === "formula_result";
    var tags = [
        {
            required: !!config.required,
            hidden: disabled || readonly || isFormulaResult,
        },
        {
            color: "default",
            label: "自動計算",
            hidden: !isFormulaResult || disabled,
        },
        {
            color: "default",
            label: "自動入力",
            hidden: !readonly || !displayAutoSetTag || disabled,
        },
        {
            color: "warn",
            label: "訂正",
            hidden: diffType !== "CHANGED",
        },
    ];
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement("div", { className: "is-vcentered is-mobile", style: { marginBottom: "12px" } }, config.label.shouldDisplay &&
                (config.parent ? (
                /** 各繰り返し(confirm-repeatable-unit)の見出しが<h4>なので、<h5>に設定している */
                React__namespace.createElement("h5", { className: "label", id: confirmFieldId },
                    config.label.text,
                    React__namespace.createElement(grafferDesignKit.GrafferSchemasTags, { tags: tags }))) : (React__namespace.createElement("h3", { className: "label", id: confirmFieldId },
                    config.label.text,
                    React__namespace.createElement(grafferDesignKit.GrafferSchemasTags, { tags: tags }))))),
            React__namespace.createElement("div", { style: { display: "flex", alignItems: "center" } },
                React__namespace.createElement("div", { style: { width: "100%" } },
                    React__namespace.createElement("div", { className: "control", id: focusGetableAreaId }, children),
                    touched && error && (React__namespace.createElement(grafferDesignKit.ErrorMessages, { messages: error, ariaLive: "assertive" })),
                    !disabled &&
                        (isEditing || !!error) &&
                        !isFormulaResult &&
                        !readonly && (React__namespace.createElement("div", { className: "field", style: { marginTop: "0.75rem", textAlign: "center" } },
                        React__namespace.createElement(grafferDesignKit.SecondaryButton, { text: "\u7DE8\u96C6\u3092\u5B8C\u4E86\u3059\u308B", isSmall: true, onClick: function () {
                                if (onEdit === undefined) {
                                    return;
                                }
                                onEdit(config, false, true);
                            }, disabled: !!error, ref: confirmButtonRef })))),
                !disabled &&
                    !isEditing &&
                    !error &&
                    !isFormulaResult &&
                    !readonly && (React__namespace.createElement("div", { style: { width: "110px" } },
                    React__namespace.createElement(grafferDesignKit.TextButton, { text: "編集", icon: "EditIcon", onClick: function () {
                            if (onEdit === undefined) {
                                return;
                            }
                            onEdit(config, true, true);
                        }, "aria-describedby": confirmFieldId, ref: editButtonRef })))))));
};
var ConfirmFieldReadonlyTemplate = function (displayAutoSetTag) {
    return function (props) {
        return (React__namespace.createElement(ConfirmFieldTemplate, tslib.__assign({}, props, { readonly: true, displayAutoSetTag: displayAutoSetTag })));
    };
};

var ConfirmFieldTemplateRegistry = /** @class */ (function () {
    function ConfirmFieldTemplateRegistry() {
    }
    ConfirmFieldTemplateRegistry.prototype.get = function () {
        return ConfirmFieldTemplate;
    };
    ConfirmFieldTemplateRegistry.prototype.getReadOnly = function (optionals) {
        return ConfirmFieldReadonlyTemplate(!!(optionals === null || optionals === void 0 ? void 0 : optionals.displayAutoSetTags));
    };
    return ConfirmFieldTemplateRegistry;
}());
var DefaultConfirmFieldTemplateRegistry = new ConfirmFieldTemplateRegistry();

var FunctionField = function (_a) {
    var children = _a.children;
    return (React__default["default"].createElement("div", { className: "field" },
        React__default["default"].createElement("div", { className: "control" }, children)));
};

var FunctionFieldTemplateRegistry = /** @class */ (function () {
    function FunctionFieldTemplateRegistry() {
    }
    FunctionFieldTemplateRegistry.prototype.get = function (_element, _repeatable) {
        return FunctionField;
    };
    return FunctionFieldTemplateRegistry;
}());
var DefaultFunctionFieldTemplateRegistry = new FunctionFieldTemplateRegistry();

var ConfirmFunctionField = function () {
    // 原則として、「フォームの入力内容の確認」をする場面では、要素を表示しない。
    // FunctionElement の種類が増えれば、必要に応じて挙動を調整することとする。
    return React__default["default"].createElement(React__default["default"].Fragment, null);
};

var ConfirmFunctionFieldTemplateRegistry = /** @class */ (function () {
    function ConfirmFunctionFieldTemplateRegistry() {
    }
    ConfirmFunctionFieldTemplateRegistry.prototype.get = function (_element, _repeatable) {
        return ConfirmFunctionField;
    };
    return ConfirmFunctionFieldTemplateRegistry;
}());
var DefaultConfirmFunctionFieldTemplateRegistry = new ConfirmFunctionFieldTemplateRegistry();

var StaticField = function (_a) {
    var config = _a.config, children = _a.children;
    return (React__default["default"].createElement("div", { className: "field" },
        config.label.shouldDisplay && config.label.text && (React__default["default"].createElement(grafferDesignKit.GrafferSchemasTitleWrap, { title: config.label.text, id: config.formFieldId })),
        React__default["default"].createElement("div", { className: "control" }, children)));
};

var StaticFieldTemplateRegistry = /** @class */ (function () {
    function StaticFieldTemplateRegistry() {
    }
    StaticFieldTemplateRegistry.prototype.get = function (_element, _repeatable) {
        return StaticField;
    };
    return StaticFieldTemplateRegistry;
}());
var DefaultStaticFieldTemplateRegistry = new StaticFieldTemplateRegistry();

var ConfirmStaticField = function () {
    // TODO: 確認モードで表示するかどうかは仕様検討の余地あり
    return React__default["default"].createElement(React__default["default"].Fragment, null);
};

var ConfirmStaticFieldTemplateRegistry = /** @class */ (function () {
    function ConfirmStaticFieldTemplateRegistry() {
    }
    ConfirmStaticFieldTemplateRegistry.prototype.get = function (_element, _repeatable) {
        return ConfirmStaticField;
    };
    return ConfirmStaticFieldTemplateRegistry;
}());
var DefaultConfirmStaticFieldTemplateRegistry = new ConfirmStaticFieldTemplateRegistry();

var Checkboxes = function (_a) {
    var config = _a.config, value = _a.value, disabled = _a.disabled, setValue = _a.setValue, onBlur = _a.onBlur, touched = _a.touched, error = _a.error;
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasCheckBoxInputComponent, { touched: touched, onChange: function (v) { return setValue((v === null || v === void 0 ? void 0 : v.length) ? v : undefined); }, isValid: !error && (touched || !!value), name: config.formFieldId, options: config.enum, value: value, onBlur: onBlur, disabled: disabled }));
};

var NumberInput = function (_a) {
    var _b, _c, _d;
    var config = _a.config, value = _a.value, error = _a.error, touched = _a.touched, onBlur = _a.onBlur, onFocus = _a.onFocus, disabled = _a.disabled, refObj = _a.refObj, tabIndex = _a.tabIndex, setValue = _a.setValue;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "columns is-vcentered" },
            React__namespace.createElement("div", { className: "column" },
                React__namespace.createElement(grafferDesignKit.GrafferSchemasTextInputComponent, { id: config.formFieldId, value: (_b = value === null || value === void 0 ? void 0 : value.toString()) !== null && _b !== void 0 ? _b : "", name: config.formFieldId, onChange: function (e) {
                        return setValue(e.target.value === "" ? undefined : e.target.value);
                    }, onBlur: onBlur, onFocus: onFocus, type: "text", inputMode: "numeric", needStatusIcon: true, disabled: disabled, tabIndex: tabIndex, touched: touched, isValid: !error && (touched || !!value), ref: refObj, required: config.required })),
            ((_c = config.suffixDescription) === null || _c === void 0 ? void 0 : _c.shouldDisplay) &&
                ((_d = config.suffixDescription) === null || _d === void 0 ? void 0 : _d.text) && (React__namespace.createElement("div", { className: "column is-one-fifth", style: { wordBreak: "break-all" } },
                React__namespace.createElement("span", { className: "graffer-input__suffix-description" }, config.suffixDescription.text))))));
};

/*
form-builder内に同様の関数があるため表示処理の修正の場合はそちらも修正する
*/
var separateFormulaResultByComma = function (value) {
    // 小数点以下の桁をカンマ区切りにする表記は一般的でないため、小数点以下はそのまま表示する
    if (!value) {
        return "";
    }
    var _a = value.split("."), integer = _a[0], decimal = _a[1];
    var separatedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return decimal ? "".concat(separatedInteger, ".").concat(decimal) : separatedInteger;
};

var FormulaResult = function (_a) {
    var config = _a.config, value = _a.value, onChange = _a.onChange, error = _a.error, touched = _a.touched;
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasTextInputComponent, { id: config.formFieldId, value: separateFormulaResultByComma(value), name: config.formFieldId, type: "text", readOnly: true, 
        /* readonlyを指定しているため、これより下のPropsは出番がない想定だが、必須Propsのため指定しておく。
        (現在はreadOnlyを再現するのに必要最小限のPropsのみを指定している。GDKの処理で必要になったPropsは都度追加する。) */
        onChange: onChange, touched: touched, isValid: !error && (touched || !!value) }));
};

// radio-buttonの表示を変えるために擬似要素に対するstyleをform-generator.tsxで定義しているので注意
var RadioButtons = function (_a) {
    var config = _a.config, value = _a.value, onBlur = _a.onBlur, disabled = _a.disabled, setValue = _a.setValue, touched = _a.touched, error = _a.error;
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasRadioInputComponent, { touched: touched, onClick: function (v) { return setValue(v !== "" ? v : undefined); }, isValid: !error && (touched || !!value), name: config.formFieldId, options: config.enum, value: value, onBlur: onBlur, disabled: disabled }));
};

var Select = function (_a) {
    var config = _a.config, value = _a.value, setValue = _a.setValue, error = _a.error, touched = _a.touched, onChange = _a.onChange, onFocus = _a.onFocus, disabled = _a.disabled, onBlur = _a.onBlur, refObj = _a.refObj, tabIndex = _a.tabIndex;
    var handleOnChange = React__namespace.useCallback(function (e) {
        if (!e.target.value || e.target.value === "") {
            // If any options is selected, set undefined because empty string doesnt mean anything.
            // HACK: Avoid double standard to update document value.
            setValue(undefined);
        }
        else {
            onChange(e);
        }
    }, []);
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasSelectComponent, { id: config.formFieldId, tabIndex: tabIndex, ref: refObj, touched: touched || !!value, isValid: !error && (touched || !!value), name: config.formFieldId, value: value, blank: true, placeholder: "選択してください", onBlur: onBlur, onFocus: onFocus, onChange: handleOnChange, disabled: disabled, options: config.enum, "data-testid": "select", required: config.required }));
};

var TextInput = function (_a) {
    var config = _a.config, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, error = _a.error, touched = _a.touched, disabled = _a.disabled, refObj = _a.refObj, tabIndex = _a.tabIndex, autoComplete = _a.autoComplete;
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasTextInputComponent, { id: config.formFieldId, value: value !== null && value !== void 0 ? value : "", name: config.formFieldId, placeholder: config.placeholder, onChange: onChange, onBlur: onBlur, onFocus: onFocus, type: "text", needStatusIcon: true, disabled: disabled, tabIndex: tabIndex, touched: touched, isValid: !error && (touched || !!value), ref: refObj, required: config.required, autoComplete: autoComplete }));
};

var TextArea = function (_a) {
    var config = _a.config, onChange = _a.onChange, value = _a.value, onBlur = _a.onBlur, onFocus = _a.onFocus, disabled = _a.disabled, error = _a.error, touched = _a.touched, refObj = _a.refObj, tabIndex = _a.tabIndex;
    var maxLength = React__namespace.useMemo(function () {
        var _a;
        var value = (_a = config.validations.find(function (validation) { return validation.keyword === "maxLength"; })) === null || _a === void 0 ? void 0 : _a.value;
        if (typeof value === "number") {
            return value;
        }
        return formSchema.ValidationErrorVariables.text_area.defaultMaxLength;
    }, [config.validations]);
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasTextAreaComponent, { touched: touched, value: value, name: config.formFieldId, placeholder: config.placeholder, onChange: onChange, onFocus: onFocus, ref: refObj, onBlur: onBlur, disabled: disabled, rows: config.rows, isValid: !error && (touched || !!value), tabIndex: tabIndex, resize: "vertical", fullWidth: true, required: config.required, maxLength: maxLength }));
};

var EmailInput = function (_a) {
    var config = _a.config, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, setValue = _a.setValue, error = _a.error, touched = _a.touched, disabled = _a.disabled, refObj = _a.refObj, tabIndex = _a.tabIndex;
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasTextInputComponent, { id: config.formFieldId, value: value !== null && value !== void 0 ? value : "", name: config.formFieldId, onChange: function (e) {
            if (!e.target.value || e.target.value === "") {
                setValue(undefined);
            }
            else {
                onChange(e);
            }
        }, placeholder: config.placeholder, onBlur: onBlur, onFocus: onFocus, type: "email", needStatusIcon: true, disabled: disabled, tabIndex: tabIndex, touched: touched, isValid: !error && (touched || !!value), ref: refObj, required: config.required }));
};

var convertDateToString = function (d, format) {
    if (!d)
        return undefined;
    return dateFns.format(d, format);
};
var splitValue$1 = function (value) {
    var _a, _b, _c, _d, _e;
    var split = (value === null || value === void 0 ? void 0 : value.match(/^\d{4}\D\d{1,2}\D\d{1,2}$/))
        ? value === null || value === void 0 ? void 0 : value.split(/\D/)
        : [];
    return {
        year: (_a = split[0]) !== null && _a !== void 0 ? _a : "",
        month: (_c = (_b = split[1]) === null || _b === void 0 ? void 0 : _b.replace(/^0(\d)$/, "$1")) !== null && _c !== void 0 ? _c : "",
        day: (_e = (_d = split[2]) === null || _d === void 0 ? void 0 : _d.replace(/^0(\d)$/, "$1")) !== null && _e !== void 0 ? _e : "",
    };
};
/**
 * 全角数字を半角数字に変換する
 * @param value
 * @returns
 */
var convertFullToHalfWidth = function (value) {
    if (!value)
        return "";
    var v = value.trim();
    if (!v.match(/[０-９-0-9]/g))
        return "";
    return v.replace(/[０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
};
/**
 * 全角の場合maxLength属性を設定していても、上限を超えて送られてくるのでlengthをチェックする
 */
var checkLengths = function (_a) {
    var year = _a.year, month = _a.month, day = _a.day;
    if (year.length <= 4 && month.length <= 2 && day.length <= 2) {
        return true;
    }
};
var useDateValueState = function (value, dateInputFormat, setValue, onBlur) {
    var dateFormat = dateInputFormat.getValue();
    var _a = React.useState(splitValue$1(value)), dateValue = _a[0], setDateValue = _a[1];
    var setNewValue = React.useCallback(function (_a) {
        var year = _a.year, month = _a.month, day = _a.day;
        var newDateValue = {
            year: convertFullToHalfWidth(year),
            month: convertFullToHalfWidth(month),
            day: convertFullToHalfWidth(day),
        };
        if (!checkLengths(newDateValue))
            return;
        setDateValue(newDateValue);
    }, [dateValue, setDateValue, setValue, dateFormat]);
    var onChangeDate = React.useCallback(function (d) {
        if (!d) {
            setDateValue({
                year: "",
                month: "",
                day: "",
            });
            setValue(undefined);
            return;
        }
        var _a = [
            String(d.getFullYear()),
            String(d.getMonth() + 1),
            String(d.getDate()),
        ], year = _a[0], month = _a[1], day = _a[2];
        setDateValue({
            year: year,
            month: month,
            day: day,
        });
        setValue(convertDateToString(d, "yyyy/MM/dd"));
    }, []);
    var onSetDate = React.useCallback(function (value) {
        var d = value ? new Date(value) : null;
        onChangeDate(d);
    }, []);
    var onComplete = React.useCallback(function (e) {
        onBlur(e);
        if (!dateValue.year || !dateValue.month || !dateValue.day) {
            value && setValue(undefined);
            return;
        }
        // moment#formatは4桁ではない文字列をYYYYでフォーマットすると2000近くに値を変換してしまうので
        // 必ず4桁であることを確認する
        // FYI: https://momentjs.com/docs/#/parsing/string-format/
        if (!dateValue.year.match(/^\d{4}$/)) {
            value && setValue(undefined);
            return;
        }
        var dateArray = [dateValue.year, dateValue.month, dateValue.day];
        var date = moment__default["default"](dateArray, dateFormat);
        setValue(date.format(dateFormat));
    }, [value, dateValue, setValue, onBlur]);
    /**
     * 初期値がある場合のセット
     */
    React.useEffect(function () {
        if (value === "Invalid date") {
            return;
        }
        setDateValue(splitValue$1(value));
    }, [value]);
    return {
        dateValue: dateValue,
        setNewValue: setNewValue,
        onChangeDate: onChangeDate,
        onComplete: onComplete,
        onSetDate: onSetDate,
    };
};

/**
 * 複数に分割された年月日入力フォーム
 */
var DateMultiInput = function (_a) {
    var _b = _a.autoComplete, autoComplete = _b === void 0 ? undefined : _b, dateInputFormat = _a.dateInputFormat, formFieldId = _a.formFieldId, value = _a.value, onBlur = _a.onBlur, error = _a.error, touched = _a.touched, setValue = _a.setValue, disabled = _a.disabled, required = _a.required;
    var _c = useDateValueState(value, dateInputFormat, setValue, onBlur), dateValue = _c.dateValue, setNewValue = _c.setNewValue, onChangeDate = _c.onChangeDate, onSetDate = _c.onSetDate, onComplete = _c.onComplete;
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasDateInputComponent, { touched: touched, errorMessage: error, value: value, onChangeDate: onChangeDate, onSetDate: onSetDate, yearInputProps: {
            dataTestId: "".concat(formFieldId, "_year"),
            name: formFieldId,
            value: dateValue.year,
            disabled: disabled,
            maxLength: 4,
            onChange: function (_a) {
                var target = _a.target;
                setNewValue(tslib.__assign(tslib.__assign({}, dateValue), { year: target.value }));
            },
            required: required,
            autoComplete: autoComplete === "bday" ? "bday-year" : undefined,
        },
        monthInputProps: {
            dataTestId: "".concat(formFieldId, "_month"),
            name: formFieldId,
            value: dateValue.month,
            disabled: disabled,
            maxLength: 2,
            onChange: function (_a) {
                var target = _a.target;
                setNewValue(tslib.__assign(tslib.__assign({}, dateValue), { month: target.value }));
            },
            required: required,
            autoComplete: autoComplete === "bday" ? "bday-month" : undefined,
        },
        dayInputProps: {
            dataTestId: "".concat(formFieldId, "_day"),
            name: formFieldId,
            value: dateValue.day,
            disabled: disabled,
            maxLength: 2,
            required: required,
            onChange: function (_a) {
                var target = _a.target;
                setNewValue(tslib.__assign(tslib.__assign({}, dateValue), { day: target.value }));
            },
            autoComplete: autoComplete === "bday" ? "bday-day" : undefined,
        },
        onBlur: onComplete }));
};

/**
 * 日付の入力時に必要な項目の付与を行う
 */
var DateInputFormatValueObject = /** @class */ (function () {
    function DateInputFormatValueObject(value) {
        this.value = value;
    }
    DateInputFormatValueObject.prototype.getValue = function () {
        return this.value.getValue();
    };
    /**
     * Unicode Technical Standard #35に従ったDateFormatを返す
     * date-fns - modern JavaScript date utility library https://date-fns.org/docs/parse
     */
    DateInputFormatValueObject.prototype.getTr35DateFormat = function () {
        return this.value.getValue().toLowerCase().replace("mm", "MM");
    };
    /**
     * カレンダーの先頭部分のUnicode Technical Standard #35に従ったフォーマットを返す
     */
    DateInputFormatValueObject.prototype.dateFormatCalendar = function () {
        return "yyyy年MM月";
    };
    /**
     * input[type="date"]のplaceholder
     */
    DateInputFormatValueObject.prototype.placeholderText = function () {
        return this.value
            .getValue()
            .replace(/y+/i, "年")
            .replace(/m+/i, "月")
            .replace(/d+/i, "日");
    };
    return DateInputFormatValueObject;
}());

/**
 * 年月日入力フォーム
 */
var DateInput = function (_a) {
    var error = _a.error, touched = _a.touched, value = _a.value, props = tslib.__rest(_a, ["error", "touched", "value"]);
    var dateInputFormat = new DateInputFormatValueObject(props.config.dateFormatValue);
    var handleOnChange = React__namespace.useCallback(function (value) {
        props.setValue(value);
    }, [props.setValue]);
    return props.config.formTypeValue.matchType({
        DatePicker: function () { return (React__namespace.createElement("div", { className: "columns is-marginless is-vcentered is-mobile is-marginless", ref: props.refObj, tabIndex: props.tabIndex },
            React__namespace.createElement("div", { className: "column has-text-left", style: {
                    padding: "0 6px 0 0",
                } },
                React__namespace.createElement(grafferDesignKit.GrafferSchemasDayInputComponent, tslib.__assign({}, props, { isValid: !error && (touched || !!value), "data-testid": "date", value: value, placeholder: "", touched: touched, required: props.config.required, name: props.config.formFieldId }))))); },
        MultiInput: function () { return (React__namespace.createElement(DateMultiInput, tslib.__assign({}, props, { value: value, touched: touched, error: error, formFieldId: props.config.formFieldId, dateInputFormat: dateInputFormat, refObj: props.refObj, tabIndex: props.tabIndex, autoComplete: props.autoComplete, required: props.config.required }))); },
        SelectInput: function () { return (React__namespace.createElement("div", { className: "columns is-marginless is-vcentered is-mobile is-marginless", ref: props.refObj, tabIndex: props.tabIndex },
            React__namespace.createElement("div", { className: "column has-text-left", style: {
                    padding: "0 6px 0 0",
                }, "data-testid": "test-date-input-select" },
                React__namespace.createElement(grafferDesignKit.GrafferSchemasYearMonthDayInput, tslib.__assign({}, props, { onChange: handleOnChange, isValid: !error && (touched || !!value), "data-testid": "date", value: value !== null && value !== void 0 ? value : "", touched: touched, name: props.config.formFieldId, autoComplete: props.autoComplete === "bday"
                        ? {
                            year: "bday-year",
                            month: "bday-month",
                            day: "bday-day",
                        }
                        : undefined, baseYear: props.config.baseYear }))))); },
    })();
};

var TelInput = function (_a) {
    var config = _a.config, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, error = _a.error, disabled = _a.disabled, touched = _a.touched, refObj = _a.refObj, tabIndex = _a.tabIndex;
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasTextInputComponent, { id: config.formFieldId, value: value !== null && value !== void 0 ? value : "", name: config.formFieldId, onChange: onChange, onBlur: onBlur, onFocus: onFocus, type: "tel", inputMode: "tel", needStatusIcon: true, disabled: disabled, tabIndex: tabIndex, touched: touched, isValid: !error && (touched || !!value), ref: refObj, required: config.required }));
};

var useFileInputState = function (value, setValue) {
    var _a = React.useState({
        rawValue: null,
        exchangeError: null,
    }), result = _a[0], setResult = _a[1];
    var _b = useFileRefKeyExchanger(), refkeyToValue = _b.refkeyToValue, valueToRefKey = _b.valueToRefKey, clearRefKey = _b.clearRefKey;
    var setRawValue = React.useCallback(function (v) {
        setResult({
            rawValue: v,
            exchangeError: null,
        });
    }, [setResult]);
    var setExchangeError = React.useCallback(function (v) {
        setResult({
            rawValue: null,
            exchangeError: v,
        });
    }, [setResult]);
    React.useEffect(function () {
        if (value !== undefined) {
            refkeyToValue(value).then(setRawValue).catch(setExchangeError);
        }
        else {
            setRawValue(null);
        }
    }, [refkeyToValue, value]);
    return {
        result: result,
        setFile: function (file) {
            valueToRefKey(file, value).then(setValue).catch(setExchangeError);
        },
        clearFile: function () {
            setValue(undefined);
            clearRefKey(value);
        },
    };
};

var dataURItoBlob = function (dataURI) {
    var byteString = atob(dataURI.split(",")[1]);
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new window.Blob([ab], { type: mimeString });
};
var getUrl = function (dataURI) {
    var blob = dataURItoBlob(dataURI);
    var objURL = window.URL.createObjectURL(blob);
    return objURL;
};
/**
 * DataURIの本体部分の文字列をファイルとして認識してブラウザで開くUtil
 */
var openDataURIContent = function (params) {
    var blob = dataURItoBlob(params.dataURI);
    var objURL = window.URL.createObjectURL(blob);
    //IE対応
    if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, params.filename);
    }
    else {
        window.open(objURL, "_blank");
    }
    setTimeout(function () { return window.URL.revokeObjectURL(objURL); }, 2500);
};

function matchFileURIType(uri, matcher) {
    if (uri.startsWith("https:") ||
        uri.startsWith("http:") ||
        uri.startsWith("/")) {
        return matcher["link"];
    }
    if (uri.startsWith("data")) {
        return matcher["dataURI"];
    }
    return matcher["unknown"];
}

function isFileInputExchangeError(e) {
    return !!e.isFileInputExchangeError;
}
var FileInput = function (_a) {
    var config = _a.config, value = _a.value, onBlur = _a.onBlur, onFocus = _a.onFocus, error = _a.error, touched = _a.touched, disabled = _a.disabled, setValue = _a.setValue;
    var _b = useFileInputState(value, setValue), _c = _b.result, rawValue = _c.rawValue, exchangeError = _c.exchangeError, clearFile = _b.clearFile, setFile = _b.setFile;
    var _d = React.useState(false), isLoading = _d[0], setLoading = _d[1];
    React.useEffect(function () {
        if (rawValue) {
            setLoading(false);
        }
    }, [rawValue]);
    var onChange = React__namespace.useCallback(function (e) {
        setLoading(true);
        if (!e.target.files || !e.target.files.length) {
            setLoading(false);
            return;
        }
        var file = e.target.files[0];
        var error = config.validateFile({
            name: file.name,
            size: file.size,
            type: file.type,
        });
        if (error) {
            alert(error);
            setLoading(false);
            return;
        }
        setFile(file);
    }, [config]);
    var state = React__namespace.useMemo(function () {
        if (disabled)
            return "disabled";
        if (isLoading)
            return "loading";
        if (exchangeError || (!!error && touched))
            return "apiError";
        return undefined;
    }, [exchangeError, error, touched, disabled, isLoading]);
    var onClickFile = React__namespace.useCallback(function () {
        if (!rawValue)
            return;
        var openFile = matchFileURIType(rawValue.uri, {
            link: function () {
                open(rawValue.uri, "_blank", "noopener noreferrer");
            },
            dataURI: function () {
                openDataURIContent({
                    dataURI: rawValue.uri,
                    filename: rawValue.name,
                });
            },
            unknown: undefined,
        });
        !!openFile && openFile();
    }, [rawValue]);
    var previewUrl = React__namespace.useMemo(function () {
        if (typeof window !== "undefined") {
            if (!rawValue)
                return "";
            var get = matchFileURIType(rawValue.uri, {
                link: function () { return rawValue.uri; },
                dataURI: function () {
                    return "".concat(getUrl(rawValue.uri));
                },
                unknown: undefined,
            });
            return get ? get() : "";
        }
        return "";
    }, [rawValue]);
    var errorMessage = React__namespace.useMemo(function () {
        if (!exchangeError)
            return undefined;
        return isFileInputExchangeError(exchangeError)
            ? exchangeError.displayError
            : "ファイル登録に失敗しました。もう一度やり直してください。";
    }, [exchangeError]);
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasSingleFileUploadComponent, { file: rawValue, disabled: disabled, onBlur: onBlur, accept: config.acceptAttributeValues, onChange: onChange, onFocus: onFocus, onClear: clearFile, previewUrl: previewUrl, name: config.formFieldId, state: state, onClickFile: onClickFile, error: {
            messages: errorMessage,
        }, required: config.required, touched: touched }));
};

var TimeInput = function (props) {
    var error = props.error, touched = props.touched, onBlur = props.onBlur, setValue = props.setValue, disabled = props.disabled, config = props.config, value = props.value;
    return (React__namespace.createElement("div", { className: "columns is-marginless is-vcentered is-mobile is-marginless" },
        React__namespace.createElement("div", { className: "column has-text-left", style: {
                padding: "0 6px 0 0",
            } },
            React__namespace.createElement(grafferDesignKit.GrafferSchemasTimeInputComponent, { id: config.formFieldId, touched: touched, name: config.formFieldId, value: value !== null && value !== void 0 ? value : "", onBlur: onBlur, placeholder: {
                    hour: "",
                    minutes: "",
                }, required: config.required, setValue: setValue, errorMessage: error, disabled: disabled, "data-testid": "time" }))));
};

var useTouchedState = function (touched, onComplete) {
    var _a = React.useState({
        from: touched,
        to: touched,
    }), touchedState = _a[0], setTouchedState = _a[1];
    var setNewTouchedState = React.useCallback(function (e, _a) {
        var from = _a.from, to = _a.to;
        var newTouchedState = {
            from: from || touchedState.from,
            to: to || touchedState.to,
        };
        setTouchedState(newTouchedState);
        if (!newTouchedState.from || !newTouchedState.to) {
            return;
        }
        onComplete(e);
        return;
    }, [touchedState, setTouchedState, onComplete]);
    return {
        touchedState: touchedState,
        setNewTouchedState: setNewTouchedState,
    };
};

var splitValue = function (value) {
    var split = (value === null || value === void 0 ? void 0 : value.match(/^\d{2}:\d{2}~\d{2}:\d{2}$/))
        ? value === null || value === void 0 ? void 0 : value.split("~")
        : [];
    return {
        from: split[0],
        to: split[1],
    };
};
var useTimeRangeValueState = function (config, value, setValue) {
    var _a = React.useState(splitValue(value)), timeRangeValue = _a[0], setTimeRangeValue = _a[1];
    useFormSubmissionContext();
    new formSchema.TimeRangeInputElement(config);
    var setNewValue = React.useCallback(function (_a) {
        var from = _a.from, to = _a.to;
        var newDateValue = {
            from: from || timeRangeValue.from,
            to: to || timeRangeValue.to,
        };
        setTimeRangeValue(newDateValue);
        if (!newDateValue.from || !newDateValue.to) {
            value && setValue(undefined);
            return;
        }
        var dateArray = [newDateValue.from, newDateValue.to];
        setValue(dateArray.join("~"));
    }, [timeRangeValue, setTimeRangeValue, setValue]);
    var clear = React.useCallback(function () {
        setTimeRangeValue({
            from: "",
            to: "",
        });
        setValue(undefined);
    }, [setTimeRangeValue, setValue]);
    return {
        timeRangeValue: timeRangeValue,
        setNewValue: setNewValue,
        clear: clear,
    };
};

/**
 * 時間レンジを入力するインプット
 */
var TimeRangeInput = function (props) {
    var _a, _b;
    var config = props.config, value = props.value, onBlur = props.onBlur, error = props.error, touched = props.touched, setValue = props.setValue, disabled = props.disabled;
    var onComplete = React.useCallback(function (e) {
        setValue(value);
        onBlur(e);
    }, [value, setValue, onBlur]);
    var _c = useTouchedState(touched, onComplete), setNewTouchedState = _c.setNewTouchedState;
    var _d = useTimeRangeValueState(config, value, setValue), timeRangeValue = _d.timeRangeValue, setNewValue = _d.setNewValue;
    return (React__namespace.createElement("div", { id: config.id, className: "columns is-mobile is-vcentered is-marginless is-paddingless" },
        React__namespace.createElement("div", null,
            React__namespace.createElement(grafferDesignKit.GrafferSchemasTimeRangeComponent, { disabled: disabled, startProps: {
                    value: (_a = timeRangeValue.from) !== null && _a !== void 0 ? _a : "",
                    setValue: function (v) {
                        setNewValue({ from: v });
                    },
                    required: config.required,
                    touched: touched,
                    errorMessage: error,
                    onBlur: function (e) {
                        setNewTouchedState(e, { from: true });
                    },
                }, endProps: {
                    value: (_b = timeRangeValue.to) !== null && _b !== void 0 ? _b : "",
                    setValue: function (v) {
                        setNewValue({ to: v });
                    },
                    required: config.required,
                    touched: touched,
                    errorMessage: error,
                    onBlur: function (e) {
                        setNewTouchedState(e, { to: true });
                    },
                } }))));
};

var ISO8601DatetimeLocalFormat = "YYYY-MM-DDTHH:mm";
/**
 * 日付範囲の入力時に必要な項目の付与を行う
 */
var DateRangeInputFormatValueObject = /** @class */ (function () {
    function DateRangeInputFormatValueObject(value) {
        this.value = value;
    }
    DateRangeInputFormatValueObject.prototype.getValue = function () {
        return this.value.getValue();
    };
    DateRangeInputFormatValueObject.prototype.convertToStateValue = function (value) {
        var split = (value === null || value === void 0 ? void 0 : value.split("~")) || [];
        return {
            from: split[0] ? this.formatToDatetimeLocal(split[0]) : "",
            to: split[1] ? this.formatToDatetimeLocal(split[1]) : "",
        };
    };
    DateRangeInputFormatValueObject.prototype.convertFromStateValue = function (value, validate) {
        if (!value.from || !value.to) {
            return;
        }
        var rangeValue = "".concat(this.formatFromDatetimeLocal(value.from), "~").concat(this.formatFromDatetimeLocal(value.to));
        return rangeValue;
    };
    DateRangeInputFormatValueObject.prototype.formatToDatetimeLocal = function (value) {
        return moment__default["default"](value).format(ISO8601DatetimeLocalFormat);
    };
    DateRangeInputFormatValueObject.prototype.formatFromDatetimeLocal = function (value) {
        return moment__default["default"](value).format(this.value.getValue());
    };
    return DateRangeInputFormatValueObject;
}());

var DatetimeInput = function (props) {
    var dateInputFormat = new DateRangeInputFormatValueObject(props.config.dateTimeFormatValue);
    return (React__namespace.createElement("div", { className: "columns is-marginless is-vcentered is-mobile is-marginless" },
        React__namespace.createElement("div", { className: "column has-text-left", style: {
                padding: "0 6px 0 0",
            } },
            React__namespace.createElement(grafferDesignKit.GrafferSchemasTimeAndDateInputComponent, { dateTimeString: props.value
                    ? dateInputFormat.formatToDatetimeLocal(props.value)
                    : "", required: props.config.required, setValue: props.setValue, disabled: props.disabled, touched: props.touched, errorMessage: props.error, onBlur: props.onBlur, id: props.config.formFieldId }))));
};

var useDatetimerangeValueState = function (config, value, setValue) {
    var elem = new formSchema.DatetimeRangeInputElement(config);
    var dateInputFormat = new DateRangeInputFormatValueObject(config.dateTimeRangeInputElementDateFormat);
    var _a = React.useState(dateInputFormat.convertToStateValue(elem.validateFormat(value) ? value : undefined)), dateTimeRangeValue = _a[0], setDateTimeRangeValue = _a[1];
    var submissionContext = useFormSubmissionContext();
    var setNewValue = React.useCallback(function (_a) {
        var from = _a.from, to = _a.to;
        // TODO: この関数の中でエラーが発生した場合に入力と実データが食い違う問題に対処
        var newDateValue = {
            from: from || dateTimeRangeValue.from,
            to: to || dateTimeRangeValue.to,
        };
        setDateTimeRangeValue(newDateValue);
        var rangeValue = dateInputFormat.convertFromStateValue(newDateValue, function (v) {
            return !!elem.validate(v, undefined, {
                formSubmissionDate: submissionContext.submissionDate,
            });
        });
        if (!rangeValue) {
            value && setValue(undefined);
            return;
        }
        setValue(rangeValue);
    }, [dateTimeRangeValue, setDateTimeRangeValue, setValue, submissionContext]);
    return {
        dateTimeRangeValue: dateTimeRangeValue,
        setNewValue: setNewValue,
    };
};

/**
 * 日付時間レンジを入力するインプット
 */
var DatetimeRangeInput = function (props) {
    var config = props.config, value = props.value, onBlur = props.onBlur, error = props.error, touched = props.touched, setValue = props.setValue, disabled = props.disabled;
    var _a = useDatetimerangeValueState(config, value, setValue), dateTimeRangeValue = _a.dateTimeRangeValue, setNewValue = _a.setNewValue;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "columns is-mobile is-vcentered is-marginless is-paddingless is-multiline" },
            React__namespace.createElement("div", null,
                React__namespace.createElement(grafferDesignKit.GrafferSchemasTimeAndDateRangeInputComponent, { touched: touched, onBlur: onBlur, startValue: dateTimeRangeValue.from, endValue: dateTimeRangeValue.to, format: "YYYY/MM/DD HH:mm", setValue: function (from, to) {
                        setNewValue({
                            from: from,
                            to: to,
                        });
                    }, required: config.required, id: config.formFieldId, disabled: disabled, errorMessage: error })))));
};

var useMyNumberInputState = function (value, setValue) {
    var _a = useMyNumberRefKeyExchanger(), refkeyToValue = _a.refkeyToValue, valueToRefKey = _a.valueToRefKey, clearRefKey = _a.clearRefKey;
    var _b = React.useState({
        // コンポーネント初期化時に値を初期の値をとってくるようにする
        rawValue: value !== undefined && value !== "" ? refkeyToValue(value).value : null,
    }), result = _b[0], setResult = _b[1];
    React.useEffect(function () {
        if (value !== undefined && value !== "") {
            // make sure the local state value and registered value is same.
            var externalHoldValue = refkeyToValue(value).value;
            if (externalHoldValue !== result.rawValue) {
                throw new Error("external value and local state is mismatched.");
            }
        }
    }, [value, result.rawValue, refkeyToValue]);
    return {
        result: result,
        setMyNumber: function (mynumber) {
            // この一連の処理のなかでLocalState、refKey <> 実データの関連付けオブジェクトのデータを一貫して変更しなければならない
            // そうなっていない場合は、useEffectでの一貫性チェックのアサーションでエラーになる
            // rawDataを外の世界にわたし、refKeyと交換する
            // このタイミングで refKeyToValueで返ってくる値も更新されている
            var refKey = valueToRefKey(mynumber, value);
            if (!refKey) {
                throw new Error("MyNumberRawValue must be exchanged to refKey");
            }
            // Formikの持っている値を更新
            setValue(refKey);
            // ローカルステートを更新
            setResult({ rawValue: mynumber });
        },
        clearMyNumber: function () {
            // setMyNumberと同様の注意事項
            clearRefKey(value);
            setValue("");
            setResult({ rawValue: null });
        },
    };
};

var MyNumberInput = function (_a) {
    var config = _a.config, value = _a.value, setValue = _a.setValue, onBlur = _a.onBlur, onFocus = _a.onFocus, error = _a.error, touched = _a.touched, disabled = _a.disabled;
    var _b = useMyNumberInputState(value, setValue), rawValue = _b.result.rawValue, clearMyNumber = _b.clearMyNumber, setMyNumber = _b.setMyNumber;
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasNumberInputFormatComponent, { type: "text", inputMode: "numeric", touched: touched, isValid: !error && (touched || !!value), name: config.formFieldId, "data-testid": "".concat(config.formFieldId, "_view"), value: rawValue || "", valueIsNumericString: true, onValueChange: function (e) {
            if (e.value === "") {
                // 値がなくなったらRefKeyをクリアする
                clearMyNumber();
            }
            else {
                setMyNumber(e.value);
            }
        }, onBlur: onBlur, onFocus: onFocus, disabled: disabled, format: "#### #### ####", needStatusIcon: true, required: config.required }));
};

var useRangeState = function (_a) {
    var value = _a.value, error = _a.error, setValue = _a.setValue, validate = _a.validate;
    var values = (value || "").split("~");
    var _b = React.useState({
        from: values[0] || "",
        to: values[1] || "",
    }), currentValue = _b[0], setCurrentValue = _b[1];
    var currentError = React.useState(error)[0];
    var submissionContext = useFormSubmissionContext();
    var setNewValue = React.useCallback(function (newValue) {
        var newValueString = newValue.from || newValue.to ? "".concat(newValue.from, "~").concat(newValue.to) : "";
        setCurrentValue(newValue);
        setValue && setValue(newValueString);
    }, [setCurrentValue, setValue, validate, submissionContext]);
    var setFromValue = React.useCallback(function (fromValue) {
        setNewValue(tslib.__assign(tslib.__assign({}, currentValue), { from: fromValue || "" }));
    }, [currentValue, setNewValue]);
    var setToValue = React.useCallback(function (toValue) {
        setNewValue(tslib.__assign(tslib.__assign({}, currentValue), { to: toValue || "" }));
    }, [currentValue, setNewValue]);
    var setDateRangeValue = React.useCallback(function (startValue, endValue) {
        setNewValue({
            from: startValue !== null && startValue !== void 0 ? startValue : "",
            to: endValue !== null && endValue !== void 0 ? endValue : "",
        });
    }, []);
    return {
        currentValue: currentValue,
        currentError: currentError,
        setFromValue: setFromValue,
        setToValue: setToValue,
        setDateRangeValue: setDateRangeValue,
    };
};

/**
 * 年月日範囲入力フォーム
 */
var DateRangeInput = function (props) {
    var _a = useRangeState(tslib.__assign(tslib.__assign({}, props), { validate: new formSchema.DateRangeInputElement(props.config).validate.bind(props.config) })), currentValue = _a.currentValue, setDateRangeValue = _a.setDateRangeValue, setFromValue = _a.setFromValue, setToValue = _a.setToValue;
    return props.config.formTypeValue.matchType({
        DatePicker: function () { return (React__namespace.createElement("div", { className: "control", ref: props.refObj },
            React__namespace.createElement("div", { className: "columns is-mobile is-vcentered is-marginless is-paddingless" },
                React__namespace.createElement("div", null,
                    React__namespace.createElement(grafferDesignKit.GrafferSchemasMultipleDateRangeInputComponent, { startValue: currentValue.from, endValue: currentValue.to, touched: props.touched, errorMessage: props.error, onStartChange: setFromValue, onEndChange: setToValue, setValue: setDateRangeValue, onBlur: props.onBlur, required: props.config.required }))))); },
        MultiInput: function () { return (
        // GDKがPickerと入力を担保するので、不要
        React__namespace.createElement("div", { className: "control", ref: props.refObj },
            React__namespace.createElement("div", { className: "columns is-mobile is-vcentered is-marginless is-paddingless" },
                React__namespace.createElement("div", null,
                    React__namespace.createElement(grafferDesignKit.GrafferSchemasMultipleDateRangeInputComponent, { startValue: currentValue.from, endValue: currentValue.to, touched: props.touched, onStartChange: setFromValue, onEndChange: setToValue, setValue: setDateRangeValue, onBlur: props.onBlur, required: props.config.required }))))); },
    })();
};

/**
 * picker から年月を選択するコンポーネント。
 *
 * style は lib/input-template/date-input/date-input.tsx の
 * DatePicker 版に準じている。
 */
var YearMonthPicker = function (_a) {
    var value = _a.value, yearMonthInput = _a.yearMonthInput, setValue = _a.setValue, error = _a.error, disabled = _a.disabled, touched = _a.touched, onBlur = _a.onBlur;
    var ctx = useFormSubmissionContext();
    var handleSetValue = React__default["default"].useCallback(function (value) {
        // TODO Date型が渡ってくる懸念があるが、GrafferSchemasDayInputComponentについてはアクセシビリティチェックに向けたコンポーネント（後で差し替え予定）であるため、一旦このまま。
        if (typeof value === "string") {
            setValue(value.replace("/", "-")); // TODO GDK側の返却がYYYY/MM固定になっているが、GrafferSchemasDayInputComponentについてはアクセシビリティチェックに向けたコンポーネント（後で差し替え予定）であるため、一旦このまま。
            return;
        }
        setValue(undefined);
    }, [setValue, yearMonthInput, ctx]);
    return (React__default["default"].createElement("div", { className: "columns is-marginless is-vcentered is-mobile is-marginless" },
        React__default["default"].createElement("div", { className: "column has-text-left", style: {
                padding: "0 6px 0 0",
            } },
            React__default["default"].createElement(grafferDesignKit.GrafferSchemasDayInputComponent, { isValid: !error && (touched || !!value), "data-testid": "year-month", value: value, placeholder: "", touched: touched, disabled: disabled, setValue: handleSetValue, showMonthYearPicker: true, onChange: function () { }, onBlur: onBlur, name: yearMonthInput.formFieldId }))));
};

/**
 * 年月入力コンポーネント
 */
var YearMonthInput = function (_a) {
    var _b;
    var value = _a.value, config = _a.config, setValue = _a.setValue, error = _a.error, touched = _a.touched, disabled = _a.disabled, onBlur = _a.onBlur;
    var yearMonthValue = value ? value.replace("-", "/") : undefined; // TODO GDK以降のアクセシビリティテスト用のためadhocに対応。差し替えたタイミングで修正する
    switch ((_b = config.formType) !== null && _b !== void 0 ? _b : formSchema.YearMonthInputDefaultFormType // TODO GDK以降のアクセシビリティテストのために、一時的にPickerに統一。GDKのデザイン確定以降差し替える。
    ) {
        case "DatePicker":
            return (React__default["default"].createElement(YearMonthPicker, { value: yearMonthValue, yearMonthInput: config, setValue: setValue, error: error, disabled: disabled, touched: touched, onBlur: onBlur }));
        case "MultiInput":
            return (React__default["default"].createElement(YearMonthPicker, { value: yearMonthValue, yearMonthInput: config, setValue: setValue, error: error, disabled: disabled, touched: touched, onBlur: onBlur }));
    }
};

/**
 * コンポーネント横断のイベントを取り扱える FormEventNotifierContext を提供する。
 * 実験的な実装につき、パッケージ外への export は避けること。
 *
 * 内部ではオブザーバーパターンを利用している。
 * 原則的にはイベントを通知するのみを責務としたい。
 * (state の保持は避けたい。もし state が必要ならば observer 側のロジックへ閉じ込める)
 * 利用に際しては、無限ループを引き起こしてしまわないよう、注意深く実装、デバッグすること。
 * またイベントの notify を配置する方法 (useEffect 内で利用するなど) によっては、
 * 同じイベントが複数回 notify されることも起こりうるため、この点にも注意すること。
 * (必ずしも useEffect 内での利用を禁ずる趣旨ではなく Event ごとの observer の実装と共に都度判断されたい)
 *
 * 安定して動作することが確認できれば、既存 FormFieldInteractionContext もこちらへ統合する。
 * (AutocompleteFieldDispatcher の実行を、特定の FormEvent の notify で代替する)
 */
var FormEventNotifierContext = React__default["default"].createContext({
    addObserver: function () {
        return "";
    },
    removeObserver: function () {
        return;
    },
    notify: function () {
        return;
    },
});
var FormEventNotifierContextProvider = function (_a) {
    var children = _a.children;
    var _b = React__default["default"].useState({
        observers: {},
    }), contextState = _b[0], setContextState = _b[1];
    var newUniqueObserverId = React__default["default"].useMemo(function () {
        var counter = 0;
        return function () { return "Observer-".concat(counter++); };
    }, []);
    var addObserver = React__default["default"].useCallback(function (observer) {
        var observerId = newUniqueObserverId();
        setContextState(function (prevState) {
            var _a;
            return tslib.__assign(tslib.__assign({}, prevState), { observers: tslib.__assign(tslib.__assign({}, prevState.observers), (_a = {}, _a[observerId] = observer, _a)) });
        });
        return observerId;
    }, [newUniqueObserverId]);
    var removeObserver = React__default["default"].useCallback(function (observerId) {
        setContextState(function (prevState) {
            var nextObservers = tslib.__assign({}, prevState.observers);
            delete nextObservers[observerId];
            return tslib.__assign(tslib.__assign({}, prevState), { observers: nextObservers });
        });
    }, []);
    var notify = React__default["default"].useCallback(function (event) {
        Object.values(contextState.observers).forEach(function (observer) {
            observer(event);
        });
    }, [contextState.observers]);
    return (React__default["default"].createElement(FormEventNotifierContext.Provider, { value: {
            addObserver: addObserver,
            removeObserver: removeObserver,
            notify: notify,
        } }, children));
};
var useFormEventNotifier = function () {
    return React__default["default"].useContext(FormEventNotifierContext);
};

var PostalCodeInput = function (_a) {
    var config = _a.config, value = _a.value, onBlur = _a.onBlur, onFocus = _a.onFocus, error = _a.error, disabled = _a.disabled, touched = _a.touched, setValue = _a.setValue, hiddenButton = _a.hiddenButton;
    var _b = React__namespace.useState(undefined), fieldError = _b[0], setFieldError = _b[1];
    var _c = React__namespace.useState(value), inputValue = _c[0], setInputValue = _c[1];
    var dispatcher = useAutocompleteFieldDispatcher();
    var addressSearchBaseUrl = useExternalServiceUrlConfig().addressSearchBaseUrl;
    var onClick = React__namespace.useCallback(function (inputValue) { return tslib.__awaiter(void 0, void 0, void 0, function () {
        var values;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, config.mapToAddress(addressSearchBaseUrl, inputValue)];
                case 1:
                    values = _a.sent();
                    if (typeof values === "string") {
                        setFieldError(values);
                    }
                    if (typeof values !== "string") {
                        setFieldError(undefined);
                        dispatcher({ values: values });
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [config, addressSearchBaseUrl, dispatcher, setFieldError]);
    var _d = React__namespace.useState(false), isFocused = _d[0], setFocused = _d[1];
    React__namespace.useEffect(function () {
        if (inputValue !== value && !isFocused) {
            setInputValue(value);
        }
    }, [inputValue, value, isFocused, setInputValue]);
    var notify = useFormEventNotifier().notify;
    React__namespace.useEffect(function () {
        var payload = {
            postalCodeElementId: config.formFieldId,
            addressCompleteTarget: config.addressCompleteTarget,
        };
        notify({
            name: hiddenButton
                ? "POSTAL_CODE_SEARCH_BUTTON_HIDDEN"
                : "POSTAL_CODE_SEARCH_BUTTON_SHOWN",
            payload: payload,
        });
        return function () {
            notify({
                name: "POSTAL_CODE_SEARCH_BUTTON_HIDDEN",
                payload: payload,
            });
        };
    }, [hiddenButton, config.formFieldId, config.addressCompleteTarget, notify]);
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(grafferDesignKit.PostalCodeSearchInput, { id: config.formFieldId, name: config.formFieldId, value: inputValue !== null && inputValue !== void 0 ? inputValue : "", onChange: function (e) {
                setInputValue(e.target.value);
                setValue(e.target.value.replace(/[^0-9]+/g, ""));
                setFieldError(undefined);
            }, onClickButton: onClick, onBlur: function (e) {
                setFocused(false);
                onBlur(e);
            }, onFocus: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                setFocused(true);
                onFocus.apply(void 0, args);
            }, disabled: disabled, touched: touched, isValid: !error && (touched || !!value), 
            // エラーメッセージが表示されるときのみ、エラーメッセージのIDを設定する
            errorMessageWithFetchDataId: fieldError ? "errorMessage-" + config.formFieldId : undefined, hiddenButton: hiddenButton, required: config.required, postalCodeSearchHelperTextId: formSchema.getPostalCodeHelperTextId(config.formFieldId) }),
        React__namespace.createElement(grafferDesignKit.ErrorMessages, { messages: fieldError, id: "errorMessage-" + config.formFieldId })));
};

var InputElements = /** @class */ (function () {
    function InputElements() {
        this.map = {
            checkboxes: Checkboxes,
            number: NumberInput,
            radio_buttons: RadioButtons,
            select: Select,
            text: TextInput,
            text_area: TextArea,
            email: EmailInput,
            date: DateInput,
            date_range: DateRangeInput,
            time: TimeInput,
            time_range: TimeRangeInput,
            datetime: DatetimeInput,
            datetime_range: DatetimeRangeInput,
            tel: TelInput,
            file: FileInput,
            my_number: MyNumberInput,
            formula_result: FormulaResult,
            year_month: YearMonthInput,
            postal_code: PostalCodeInput,
        };
    }
    InputElements.prototype.get = function (elem, _) {
        return this.map[elem.inputType];
    };
    return InputElements;
}());
var DefaultInputTemplateRegistry = new InputElements();

var OriginalValueView = function (_a) {
    var config = _a.config, setValue = _a.setValue;
    var detector = React.useContext(FormContext).modificationContext.detector;
    // is not modifying
    if (detector === undefined) {
        return null;
    }
    var original = detector.getOriginalValue(config);
    var label = detector.getOriginalLabel(config);
    var onReset = function () {
        setValue && setValue(original);
    };
    return (React__namespace.createElement("div", { className: "columns is-mobile", style: {
            marginBottom: 0,
        } },
        React__namespace.createElement("div", { className: "column", style: { whiteSpace: "pre-wrap", wordBreak: "break-all" } },
            !label && React__namespace.createElement("span", { className: "tag is-small" }, "\u5165\u529B\u306A\u3057"),
            Array.isArray(label) ? label.map(function (v, i) { return React__namespace.createElement("p", { key: i }, v); }) : label),
        detector.checkInput(config) === "CHANGED" &&
            config.inputType !== "formula_result" && (React__namespace.createElement("div", { className: "column is-narrow" },
            React__namespace.createElement("button", { className: "is-size-6", style: {
                    border: "none",
                    padding: "0 !important",
                    color: "#069",
                    textDecoration: "underline",
                    cursor: "pointer",
                    backgroundColor: "transparent",
                }, onClick: onReset }, "\u5143\u306B\u623B\u3059")))));
};

var TextConfirmInput = function (_a) {
    var _b, _c;
    var config = _a.config, value = _a.value, error = _a.error, setValue = _a.setValue, props = tslib.__rest(_a, ["config", "value", "error", "setValue"]);
    var editIds = React.useContext(FormContext).confirmContext.editIds;
    var isEditing = editIds === null || editIds === void 0 ? void 0 : editIds.includes(config.formFieldId);
    var Input = DefaultInputTemplateRegistry.get(config);
    if (isEditing || !!error) {
        return (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(OriginalValueView, { config: config, setValue: setValue }),
            React__namespace.createElement(Input, tslib.__assign({ config: config, value: value, error: error, setValue: setValue }, props, { disabled: false }))));
    }
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("div", { className: "columns is-vcentered" },
            React__namespace.createElement("div", { className: "column" },
                React__namespace.createElement("p", { "data-elem-id": config.formFieldId }, value)),
            value &&
                ((_b = config.suffixDescription) === null || _b === void 0 ? void 0 : _b.shouldDisplay) &&
                ((_c = config.suffixDescription) === null || _c === void 0 ? void 0 : _c.text) && (React__namespace.createElement("div", { className: "column is-one-fifth", style: { wordBreak: "break-all" } },
                React__namespace.createElement("span", { className: "graffer-input__suffix-description" }, config.suffixDescription.text))))));
};

var SelectableConfirmInput = function (_a) {
    var config = _a.config, value = _a.value, error = _a.error, setValue = _a.setValue, props = tslib.__rest(_a, ["config", "value", "error", "setValue"]);
    if (!formSchema.isSelectableClassElement(config)) {
        throw new Error("config must be selectable but " + JSON.stringify(config));
    }
    var editIds = React.useContext(FormContext).confirmContext.editIds;
    var isEditing = editIds === null || editIds === void 0 ? void 0 : editIds.includes(config.formFieldId);
    var Input = DefaultInputTemplateRegistry.get(config);
    if (isEditing || !!error) {
        return (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(OriginalValueView, { config: config, setValue: setValue }),
            React__namespace.createElement(Input, tslib.__assign({ config: config, value: value, error: error, setValue: setValue }, props, { disabled: false }))));
    }
    return (React__namespace.createElement("div", { "data-elem-id": config.formFieldId },
        formSchema.isCheckboxesElement(config) &&
            config.enum
                .filter(function (e) { return value === null || value === void 0 ? void 0 : value.includes(e.value); })
                .map(function (e) { return (React__namespace.createElement("p", { key: e.value, style: { paddingBottom: 2 } }, e.text)); }),
        !formSchema.isCheckboxesElement(config) && (React__namespace.createElement(React__namespace.Fragment, null, config.enum
            .filter(function (e) { return e.value === value; })
            .map(function (v) { return v.text; })))));
};

var FileConfirmInput = function (_a) {
    var config = _a.config, value = _a.value, error = _a.error, setValue = _a.setValue, props = tslib.__rest(_a, ["config", "value", "error", "setValue"]);
    var _b = useFileInputState(value, setValue).result, rawValue = _b.rawValue, exchangeError = _b.exchangeError;
    var editIds = React.useContext(FormContext).confirmContext.editIds;
    var isEditing = editIds === null || editIds === void 0 ? void 0 : editIds.includes(config.formFieldId);
    var Input = DefaultInputTemplateRegistry.get(config);
    if (isEditing || !!error) {
        return (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(OriginalValueView, { config: config, setValue: setValue }),
            React__namespace.createElement(Input, tslib.__assign({ config: config, value: value, error: error, setValue: setValue }, props, { disabled: false }))));
    }
    return (React__namespace.createElement(React__namespace.Fragment, null,
        rawValue && (React__namespace.createElement("div", null, matchFileURIType(rawValue.uri, {
            link: (React__namespace.createElement("div", null,
                React__namespace.createElement(grafferDesignKit.ExternalLink, { href: rawValue.uri }, rawValue.name))),
            dataURI: (React__namespace.createElement("div", null,
                React__namespace.createElement(grafferDesignKit.TextButton, { text: rawValue.name, icon: "ExternalLinkIcon", iconPosition: "right", onClick: function () {
                        return openDataURIContent({
                            dataURI: rawValue.uri,
                            filename: rawValue.name,
                        });
                    }, "aria-label": "".concat(rawValue.name, "\u3092\u5225\u30BF\u30D6\u3067\u958B\u304F") }))),
            unknown: React__namespace.createElement("div", null, rawValue.name),
        }))),
        exchangeError && (React__namespace.createElement("p", { className: "help is-size-7" }, isFileInputExchangeError(exchangeError)
            ? exchangeError.displayError
            : "ファイルの取得に失敗しました。"))));
};

var useMyNumberInputConfirmState = function (key, isEditing) {
    var _a = React.useState({
        rawValue: null,
    }), result = _a[0], setResult = _a[1];
    var refkeyToValue = useMyNumberRefKeyExchanger().refkeyToValue;
    var setRawValue = React.useCallback(function (v) {
        setResult({
            rawValue: v,
        });
    }, [setResult]);
    React.useEffect(function () {
        if (key !== undefined && key !== "") {
            setRawValue(refkeyToValue(key).value);
        }
        else {
            setRawValue(null);
        }
    }, [refkeyToValue, key, isEditing]);
    return {
        result: result,
    };
};

var formatMynumberValue = function (value) {
    if (!value) {
        return "";
    }
    var splitValues = value.match(/.{1,4}/g);
    return splitValues ? splitValues.join(" ") : value;
};

var MyNumberConfirmInput = function (_a) {
    var config = _a.config, value = _a.value, error = _a.error, setValue = _a.setValue, props = tslib.__rest(_a, ["config", "value", "error", "setValue"]);
    var editIds = React.useContext(FormContext).confirmContext.editIds;
    var isEditing = React.useMemo(function () { return editIds === null || editIds === void 0 ? void 0 : editIds.includes(config.formFieldId); }, [editIds, config.formFieldId]);
    var result = useMyNumberInputConfirmState(value, !!isEditing).result;
    if (isEditing || !!error) {
        return (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(OriginalValueView, { config: config, setValue: setValue }),
            React__namespace.createElement(MyNumberInput, tslib.__assign({ config: config, value: value, error: error, setValue: setValue }, props, { disabled: false }))));
    }
    return (React__namespace.createElement("p", { "data-elem-id": config.formFieldId }, formatMynumberValue(result.rawValue)));
};

var TextAreaConfirm = function (_a) {
    var config = _a.config, value = _a.value, error = _a.error, setValue = _a.setValue, props = tslib.__rest(_a, ["config", "value", "error", "setValue"]);
    var editIds = React.useContext(FormContext).confirmContext.editIds;
    var isEditing = editIds === null || editIds === void 0 ? void 0 : editIds.includes(config.formFieldId);
    var Input = DefaultInputTemplateRegistry.get(config);
    if (isEditing || !!error) {
        return (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(OriginalValueView, { config: config, setValue: setValue }),
            React__namespace.createElement(Input, tslib.__assign({ config: config, value: value, error: error, setValue: setValue }, props, { disabled: false }))));
    }
    return (React__namespace.createElement("p", { "data-elem-id": config.formFieldId, style: { whiteSpace: "pre-wrap", wordBreak: "break-all" } }, value));
};

var ConfirmInputRegistry = /** @class */ (function () {
    function ConfirmInputRegistry() {
        this.map = {
            checkboxes: SelectableConfirmInput,
            radio_buttons: SelectableConfirmInput,
            select: SelectableConfirmInput,
            number: TextConfirmInput,
            text: TextConfirmInput,
            text_area: TextAreaConfirm,
            email: TextConfirmInput,
            date: TextConfirmInput,
            date_range: TextConfirmInput,
            time: TextConfirmInput,
            time_range: TextConfirmInput,
            datetime_range: TextConfirmInput,
            datetime: TextConfirmInput,
            year_month: TextConfirmInput,
            tel: TextConfirmInput,
            file: FileConfirmInput,
            my_number: MyNumberConfirmInput,
            formula_result: TextConfirmInput,
            postal_code: TextConfirmInput, // PRのボリュームを小さくする観点で一旦1行テキスト
        };
    }
    ConfirmInputRegistry.prototype.get = function (elem, _) {
        return this.map[elem.inputType];
    };
    return ConfirmInputRegistry;
}());
var DefaultConfirmInputTemplateRegistry = new ConfirmInputRegistry();

/**
 * 「追加する」系のボタンのaria-describedbyに設定するidを返す
 * @param id reptable id
 */
var useAddButtonDescriptionId = function (id) {
    var addButtonDescriptionId = React.useMemo(function () { return "".concat(id, "-add-button-description"); }, [id]);
    return {
        addButtonDescriptionId: addButtonDescriptionId,
    };
};

var REPEATABLE_DEFAULT_UNIT = "件";
/**
 * 繰り返し項目の最大入力可能数のラベルに使用するテキストを取得する
 * @param maxLength
 * @param unitText
 * @returns
 */
var getMaxRepeatableLengthLabelText = function (maxLength, unitText) {
    if (unitText === void 0) { unitText = REPEATABLE_DEFAULT_UNIT; }
    return "\u6700\u5927".concat(maxLength).concat(unitText, "\u307E\u3067\u5165\u529B\u53EF\u80FD");
};
/**
 * 何番目の繰り返しかを示すテキストを取得する
 * @param order
 * @param unitText
 * @returns
 */
var getRepeatOrderText = function (order, unitText) {
    if (unitText === void 0) { unitText = REPEATABLE_DEFAULT_UNIT; }
    return "".concat(order).concat(unitText, "\u76EE");
};
/**
 * 繰り返し削除確認ダイアログに表示するテキストを取得する
 * @param order
 * @param unitText
 * @returns
 */
var getRepeatDeleteDialogText = function (order, unitText) {
    if (unitText === void 0) { unitText = REPEATABLE_DEFAULT_UNIT; }
    return "".concat(getRepeatOrderText(order, unitText), "\u3092\u524A\u9664\u3057\u307E\u3059\u3002\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F");
};
/**
 * コピー可能な追加ボタンに表示するテキストを取得する
 * @param order
 * @param unitText
 * @returns
 */
var getCopyableAddButtonText = function (order, unitText) {
    if (unitText === void 0) { unitText = REPEATABLE_DEFAULT_UNIT; }
    return "".concat(getRepeatOrderText(order, unitText), "\u3092\u30B3\u30D4\u30FC\u3057\u3066\u8FFD\u52A0\u3059\u308B");
};
// コピーができる場合に、コピーせずに繰り返しを追加する際に使用するボタンのテキスト
var ADD_BUTTON_TEXT_WHEN_COPYABLE = "新規追加する";
// コピーができない場合の追加ボタンのテキスト
var ADD_BUTTON_TEXT_WHEN_NOT_COPYABLE = "もう1件追加する";

var RepeatableTemplate = function (_a) {
    var config = _a.config, values = _a.values, children = _a.children, onAdd = _a.onAdd, disabled = _a.disabled, isAddDisabled = _a.isAddDisabled;
    var addButtonDescriptionId = useAddButtonDescriptionId(config.id).addButtonDescriptionId;
    var descriptionPlain = config.description.shouldDisplay && !config.description.isMarkdown
        ? config.description.text
        : "";
    var descriptionMarkdown = config.description.shouldDisplay && !!config.description.isMarkdown
        ? config.description.text
        : "";
    var id = "repeatable-id-".concat(config.id);
    var descriptionId = "repeatable-description-id-".concat(config.id);
    var errorMessageId = "repeatable-error-message-id-".concat(config.id);
    var markdownProcessor = useMarkdownConfig().markdownProcessor;
    return (React__namespace.createElement(grafferDesignKit.GrafferSchemasContextProvider, { id: id, descriptionId: descriptionId, errorMessageId: errorMessageId },
        React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement(grafferDesignKit.GrafferSchemasFieldsetWrap, { title: config.label.shouldDisplay ? config.label.text : "", description: descriptionMarkdown ? (React__namespace.createElement(MarkdownErrorHandler, { value: descriptionMarkdown, markdownProcessor: markdownProcessor })) : (descriptionPlain), tags: [
                    {
                        required: !!config.required,
                    },
                    {
                        label: getMaxRepeatableLengthLabelText(config.maxLength),
                    },
                ] },
                React__namespace.createElement("div", { className: "control" },
                    React__namespace.createElement("div", { style: {
                            paddingLeft: "3px",
                        } },
                        children,
                        !isAddDisabled && !disabled && (React__namespace.createElement("div", { className: "field" },
                            !(values === null || values === void 0 ? void 0 : values.length) && (React__namespace.createElement("div", { className: "has-text-left", style: {
                                    marginBottom: "12px",
                                } },
                                React__namespace.createElement(grafferDesignKit.GrafferSchemasSecondaryButton, { text: "追加する", onClick: onAdd, "aria-describedby": addButtonDescriptionId, icon: "PlusIcon", iconPosition: "left", "aria-label": "\u8FFD\u52A0\u3059\u308B" }))),
                            React__namespace.createElement("div", { id: addButtonDescriptionId, className: "has-text-right" },
                                values === undefined && config.required && (React__namespace.createElement(grafferDesignKit.GrafferSchemasErrorMessages, { messages: "\u3042\u3068".concat(config.minLength, "\u4EF6\u8FFD\u52A0\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059") })),
                                values !== undefined && (React__namespace.createElement("div", { style: {
                                        marginTop: "4px",
                                    } },
                                    values.length < config.minLength && (React__namespace.createElement(grafferDesignKit.GrafferSchemasErrorMessages, { messages: "\u3042\u3068".concat(config.minLength - values.length, "\u4EF6\u8FFD\u52A0\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059") })),
                                    React__namespace.createElement("p", null, values.length >= config.minLength &&
                                        values.length < config.maxLength &&
                                        "\u3042\u3068".concat(config.maxLength - values.length, "\u4EF6\u307E\u3067\u8FFD\u52A0\u3067\u304D\u307E\u3059")))))))))))));
};

var css_248z$4 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n@media (hover: hover) {\n  .repeatable-module_clearButton__TBZDi > button:hover > svg > path {\n    fill: #5c5959;\n  }\n}\n\n.repeatable-module_clearButton__TBZDi > button:focus-visible {\n  outline: 2px solid #454ab8;\n  border-radius: 4px;\n}\n\n.repeatable-module_addButton__KZqVH {\n  color: #454ab8;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: \"pointer\";\n}\n\n@media (hover: hover) {\n  .repeatable-module_addButton__KZqVH:hover {\n    color: #3739a2;\n  }\n}\n\n.repeatable-module_addButton__KZqVH:active {\n  color: #1c1e78;\n}\n\n.repeatable-module_addButton__KZqVH:focus {\n  color: #3739a2;\n  background-color: #e8e9f7;\n}\n\n.repeatable-module_addButtonsWrapper__MZ34p {\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media screen and (max-width: 800px) {\n  .repeatable-module_addButtonsWrapper__MZ34p {\n    display: block;\n    text-align: right;\n  }\n}\n\n.repeatable-module_copyabaleAddButtonWrapper__bJQGA {\n  margin-right: 16px;\n}\n\n@media screen and (max-width: 800px) {\n  .repeatable-module_copyabaleAddButtonWrapper__bJQGA {\n    margin-right: 0px;\n    margin-bottom: 12px;\n  }\n}\n\n.repeatable-module_confirmCopyabaleAddButtonWrapper__bYbEG {\n  margin-right: 16px;\n}\n\n@media screen and (max-width: 800px) {\n  .repeatable-module_confirmCopyabaleAddButtonWrapper__bYbEG {\n    margin-right: 0px;\n    margin-bottom: 4px;\n  }\n}\n\n.repeatable-module_confirmAddFirstRepetableButtonWrapper__rpus1 {\n  text-align: right;\n}\n\n.repeatable-module_repeatOrderText__aKsRn {\n  font-weight: 600;\n  margin-right: 16px;\n}\n\n.repeatable-module_labelText__Wn9nF {\n  font-weight: 400;\n}\n\n.repeatable-module_repeatableUnit__QXQC6:focus-visible {\n  outline-offset: 4px;\n}\n";
var styles$4 = {"clearButton":"repeatable-module_clearButton__TBZDi","addButton":"repeatable-module_addButton__KZqVH","addButtonsWrapper":"repeatable-module_addButtonsWrapper__MZ34p","copyabaleAddButtonWrapper":"repeatable-module_copyabaleAddButtonWrapper__bJQGA","confirmCopyabaleAddButtonWrapper":"repeatable-module_confirmCopyabaleAddButtonWrapper__bYbEG","confirmAddFirstRepetableButtonWrapper":"repeatable-module_confirmAddFirstRepetableButtonWrapper__rpus1","repeatOrderText":"repeatable-module_repeatOrderText__aKsRn","labelText":"repeatable-module_labelText__Wn9nF","repeatableUnit":"repeatable-module_repeatableUnit__QXQC6"};
styleInject(css_248z$4);

var RepeatableUnitDeleteButton = function (_a) {
    var handleOnDelete = _a.handleOnDelete, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "削除" : _b;
    return (React__namespace.createElement("button", { onClick: handleOnDelete, "aria-label": ariaLabel },
        React__namespace.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
            React__namespace.createElement("g", { clipPath: "url(#clip0_1149_3379)" },
                React__namespace.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#1D1C1A" }),
                React__namespace.createElement("path", { d: "M17.8678 7.40396L16.5958 6.13196L11.9998 10.728L7.40384 6.13196L6.13184 7.40396L10.7278 12L6.13184 16.596L7.40384 17.868L11.9998 13.272L16.5958 17.868L17.8678 16.596L13.2718 12L17.8678 7.40396Z", fill: "white" })),
            React__namespace.createElement("defs", null,
                React__namespace.createElement("clipPath", { id: "clip0_1149_3379" },
                    React__namespace.createElement("rect", { width: "24", height: "24", fill: "white" }))))));
};

var RepeatableUnit = function (_a) {
    var config = _a.config, error = _a.error, index = _a.index, children = _a.children, onDelete = _a.onDelete, disabled = _a.disabled, isExpanded = _a.isExpanded, onToggle = _a.onToggle, isCopyable = _a.isCopyable, isAddDisabled = _a.isAddDisabled, onCopyValues = _a.onCopyValues, onAdd = _a.onAdd, focusUnitIndex = _a.focusUnitIndex, resetFocusUnitIndex = _a.resetFocusUnitIndex;
    var unitGroupRefObj = React.useRef(null);
    var detector = React__namespace.useContext(FormContext).modificationContext.detector;
    var diff = detector === null || detector === void 0 ? void 0 : detector.checkRepeatable(config);
    var isModified = diff !== undefined && diff[index] === "ADDED";
    var handleOnDelete = React.useCallback(function () {
        if (onDelete !== undefined &&
            window.confirm(getRepeatDeleteDialogText(index + 1))) {
            onDelete();
        }
    }, [onDelete, index]);
    var addButtonDescriptionId = useAddButtonDescriptionId(config.id).addButtonDescriptionId;
    var unitLabelId = React.useMemo(function () { return "".concat(config.id, "-").concat(index, "-repeatable-unit-label"); }, [config.id]);
    React.useEffect(function () {
        var _a;
        // 追加され描画した後でなくてはfocusを当てられないため、親からrefを受け取るのではなく、各unit（本コンポーネント）で自身にフォーカスを当てるかどうか判定。
        if (focusUnitIndex === index) {
            (_a = unitGroupRefObj.current) === null || _a === void 0 ? void 0 : _a.focus();
            resetFocusUnitIndex();
        }
    }, [focusUnitIndex, index]);
    return (React__namespace.createElement("div", { role: "group", "aria-labelledby": unitLabelId, tabIndex: -1, ref: unitGroupRefObj, className: "field ".concat(styles$4.repeatableUnit), style: {
            borderRadius: 3,
            marginBottom: index + 1 !== config.maxLength ? "2rem" : "0rem",
        } },
        React__namespace.createElement("div", { className: "mb-3", style: {
                border: "1px solid #CFCFCF",
                borderRadius: 3,
            } },
            React__namespace.createElement("div", { className: "columns is-marginless is-mobile has-background-light", style: {
                    paddingLeft: "12px",
                    paddingRight: "12px",
                } },
                React__namespace.createElement("div", { className: "column is-paddingless", style: {
                        marginTop: "12px",
                        marginBottom: "12px",
                        borderTopLeftRadius: 3,
                        borderTopRightRadius: 3,
                    } },
                    React__namespace.createElement("div", null,
                        onToggle && (React__namespace.createElement("span", { className: "icon", onClick: onToggle, "data-testid": "".concat(config.id, "_").concat(index, "_toggle"), "data-test-state": isExpanded }, isExpanded ? (React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faCaretDown })) : (React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faCaretRight })))),
                        React__namespace.createElement("span", { id: unitLabelId },
                            React__namespace.createElement("span", { className: "".concat(styles$4.repeatOrderText) }, getRepeatOrderText(index + 1)),
                            React__namespace.createElement("span", { className: "".concat(styles$4.labelText) }, config.label.text)),
                        React__namespace.createElement(grafferDesignKit.GrafferSchemasTags, { tags: [
                                {
                                    color: "warn",
                                    label: "訂正",
                                    hidden: !isModified,
                                },
                            ] }),
                        error && (React__namespace.createElement("p", { className: "help has-text-weight-normal is-danger" }, error)))),
                React__namespace.createElement("div", { className: "column is-paddingless has-text-right is-narrow ".concat(styles$4.clearButton), style: {
                        marginTop: "12px",
                        marginBottom: "12px",
                        borderTopLeftRadius: 3,
                        borderTopRightRadius: 3,
                    } }, !disabled && onDelete && (React__namespace.createElement(RepeatableUnitDeleteButton, { handleOnDelete: handleOnDelete })))),
            (isExpanded || !onToggle) && (React__namespace.createElement("div", { style: {
                    padding: "18px 12px 18px 12px",
                } }, children))),
        !isAddDisabled && !disabled && (React__namespace.createElement("div", { className: "".concat(styles$4.addButtonsWrapper) },
            isCopyable && (React__namespace.createElement("div", { className: "".concat(styles$4.copyabaleAddButtonWrapper) },
                React__namespace.createElement(grafferDesignKit.GrafferSchemasSecondaryButton, { text: getCopyableAddButtonText(index + 1), onClick: onCopyValues, "aria-describedby": addButtonDescriptionId, icon: "CopyForRepeatableIcon" }))),
            React__namespace.createElement("div", null,
                React__namespace.createElement(grafferDesignKit.GrafferSchemasSecondaryButton, { text: isCopyable
                        ? ADD_BUTTON_TEXT_WHEN_COPYABLE
                        : ADD_BUTTON_TEXT_WHEN_NOT_COPYABLE, onClick: onAdd, "aria-describedby": addButtonDescriptionId, "aria-label": isCopyable
                        ? ADD_BUTTON_TEXT_WHEN_COPYABLE
                        : ADD_BUTTON_TEXT_WHEN_NOT_COPYABLE, icon: "PlusIcon" }))))));
};

var RepeatableElementTemplate = /** @class */ (function () {
    function RepeatableElementTemplate() {
    }
    RepeatableElementTemplate.prototype.get = function (elem) {
        return RepeatableTemplate;
    };
    RepeatableElementTemplate.prototype.getUnit = function (type) {
        return RepeatableUnit;
    };
    return RepeatableElementTemplate;
}());
var DefaultRepeatableTemplateRegistry = new RepeatableElementTemplate();

var css_248z$3 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.confirm-repeatable-wrapper-module_repeatableWrapper__E21LJ {\n  display: inline-block;\n  width: 0;\n  min-width: 100%;\n  box-sizing: border-box;\n  border: none;\n  word-break: break-all;\n}\n\n.confirm-repeatable-wrapper-module_headingWrapper__Mn3fz {\n  margin-bottom: 8px;\n  color: #1d1c1a;\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  width: 100%;\n}\n\n@media screen and (max-width: 800px) {\n\n  .confirm-repeatable-wrapper-module_headingWrapper__Mn3fz {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.confirm-repeatable-wrapper-module_title__eOX8J {\n  display: inline;\n}\n";
var styles$3 = {"repeatableWrapper":"confirm-repeatable-wrapper-module_repeatableWrapper__E21LJ","headingWrapper":"confirm-repeatable-wrapper-module_headingWrapper__Mn3fz","title":"confirm-repeatable-wrapper-module_title__eOX8J"};
styleInject(css_248z$3);

/**
 * 確認画面の繰り返し項目のタイトルとして使用する想定です。繰り返し項目のマークアップの階層を考慮して実装しています。
 */
var ConfirmRepeatableWrapper = function (_a) {
    var title = _a.title, tags = _a.tags, children = _a.children;
    var generatedId = reactIdGenerator.useId()[0];
    var headingId = "repeadatble-heading-".concat(generatedId);
    return (React__namespace.createElement("div", { role: "group", className: styles$3.repeatableWrapper, "aria-labelledby": headingId },
        React__namespace.createElement("h3", { className: styles$3.headingWrapper, id: headingId },
            React__namespace.createElement("span", { className: styles$3.title }, title),
            !!(tags === null || tags === void 0 ? void 0 : tags.length) && (React__namespace.createElement(grafferDesignKit.GrafferSchemasTags, { tags: tags, isFirstChild: !title }))),
        children));
};

var ConfirmRepeatableTemplate = function (_a) {
    var config = _a.config, values = _a.values, children = _a.children, onAdd = _a.onAdd, isAddDisabled = _a.isAddDisabled, disabled = _a.disabled;
    var addButtonDescriptionId = useAddButtonDescriptionId(config.id).addButtonDescriptionId;
    return (React__namespace.createElement("div", { className: "field" },
        React__namespace.createElement(ConfirmRepeatableWrapper, { title: config.label.shouldDisplay ? config.label.text : "", tags: [
                {
                    required: !!config.required,
                    hidden: disabled || !config.label.shouldDisplay,
                },
                {
                    label: getMaxRepeatableLengthLabelText(config.maxLength),
                    hidden: disabled || !config.label.shouldDisplay,
                },
            ] },
            !(values === null || values === void 0 ? void 0 : values.length) && !disabled && !isAddDisabled && (React__namespace.createElement("div", { className: "".concat(styles$4.confirmAddFirstRepetableButtonWrapper) },
                React__namespace.createElement(grafferDesignKit.TextButton, { text: "追加", icon: "PlusIcon", onClick: onAdd, "aria-describedby": addButtonDescriptionId }))),
            React__namespace.createElement("div", { className: "control" },
                React__namespace.createElement("div", { style: {
                        paddingLeft: "3px",
                    } },
                    children,
                    !disabled && (React__namespace.createElement("div", { id: addButtonDescriptionId, className: "has-text-right" },
                        values === undefined && config.required && (React__namespace.createElement("p", { className: "has-text-danger" }, "\u3042\u3068".concat(config.minLength, "\u4EF6\u8FFD\u52A0\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059"))),
                        values !== undefined && values.length < config.minLength && (React__namespace.createElement("p", { className: "has-text-danger" }, "\u3042\u3068".concat(config.minLength - values.length, "\u4EF6\u8FFD\u52A0\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059"))))))))));
};

var ConfirmRepeatableUnit = function (_a) {
    var config = _a.config, error = _a.error, index = _a.index, children = _a.children, onDelete = _a.onDelete, disabled = _a.disabled, isExpanded = _a.isExpanded, onToggle = _a.onToggle, isCopyable = _a.isCopyable, isAddDisabled = _a.isAddDisabled, onCopyValues = _a.onCopyValues, onAdd = _a.onAdd, focusUnitIndex = _a.focusUnitIndex, resetFocusUnitIndex = _a.resetFocusUnitIndex;
    var unitGroupRefObj = React.useRef(null);
    var detector = React__namespace.useContext(FormContext).modificationContext.detector;
    var diff = detector === null || detector === void 0 ? void 0 : detector.checkRepeatable(config);
    var isModified = diff !== undefined && diff[index] === "ADDED";
    var handleOnDelete = React.useCallback(function () {
        if (onDelete !== undefined &&
            window.confirm(getRepeatDeleteDialogText(index + 1))) {
            onDelete();
        }
    }, [onDelete, index]);
    var addButtonDescriptionId = useAddButtonDescriptionId(config.id).addButtonDescriptionId;
    var unitLabelId = React.useMemo(function () { return "".concat(config.id, "-").concat(index, "-confirm-repeatable-unit-label"); }, [config.id]);
    React.useEffect(function () {
        var _a;
        // 追加され描画した後でなくてはfocusを当てられないため、親からrefを受け取るのではなく、各unit（本コンポーネント）で自身にフォーカスを当てるかどうか判定。
        if (focusUnitIndex === index) {
            (_a = unitGroupRefObj.current) === null || _a === void 0 ? void 0 : _a.focus();
            resetFocusUnitIndex();
        }
    }, [focusUnitIndex, index]);
    return (React__namespace.createElement("div", { role: "group", "aria-labelledby": unitLabelId, tabIndex: -1, ref: unitGroupRefObj, className: "field ".concat(styles$4.repeatableUnit), style: {
            borderRadius: 3,
            marginBottom: index + 1 !== config.maxLength ? "2rem" : "0rem",
        } },
        React__namespace.createElement("div", { className: "mb-3", style: {
                border: "1px solid #CFCFCF",
                borderRadius: 3,
            } },
            React__namespace.createElement("div", { className: "columns is-marginless is-mobile has-background-light", style: {
                    paddingLeft: "12px",
                    paddingRight: "12px",
                } },
                React__namespace.createElement("div", { className: "column is-paddingless", style: {
                        marginTop: "12px",
                        marginBottom: "12px",
                        borderTopLeftRadius: 3,
                        borderTopRightRadius: 3,
                    } },
                    React__namespace.createElement("div", null,
                        onToggle && (React__namespace.createElement("span", { className: "icon", onClick: onToggle, "data-testid": "".concat(config.id, "_").concat(index, "_toggle"), "data-test-state": isExpanded }, isExpanded ? (React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faCaretDown })) : (React__namespace.createElement(reactFontawesome.FontAwesomeIcon, { icon: freeSolidSvgIcons.faCaretRight })))),
                        React__namespace.createElement("h4", { id: unitLabelId, style: { display: "inline-block" } },
                            React__namespace.createElement("span", { className: "".concat(styles$4.repeatOrderText) }, getRepeatOrderText(index + 1)),
                            React__namespace.createElement("span", { className: "".concat(styles$4.labelText) }, config.label.text)),
                        React__namespace.createElement(grafferDesignKit.GrafferSchemasTags, { tags: [
                                {
                                    color: "warn",
                                    label: "訂正",
                                    hidden: !isModified,
                                },
                            ] }),
                        error && (React__namespace.createElement("p", { className: "help has-text-weight-normal is-danger" }, error)))),
                React__namespace.createElement("div", { className: "column is-paddingless has-text-right is-narrow ".concat(styles$4.clearButton), style: {
                        marginTop: "12px",
                        marginBottom: "12px",
                        borderTopLeftRadius: 3,
                        borderTopRightRadius: 3,
                    } }, !disabled && onDelete && (React__namespace.createElement(RepeatableUnitDeleteButton, { handleOnDelete: handleOnDelete })))),
            (isExpanded || !onToggle) && (React__namespace.createElement("div", { style: {
                    padding: "18px 12px 18px 12px",
                } }, children))),
        !disabled && !isAddDisabled && (React__namespace.createElement("div", { className: "".concat(styles$4.addButtonsWrapper) },
            isCopyable && (React__namespace.createElement("div", { className: "".concat(styles$4.confirmCopyabaleAddButtonWrapper) },
                React__namespace.createElement("button", { className: "is-size-6 ".concat(styles$4.addButton), onClick: onCopyValues, "aria-describedby": addButtonDescriptionId }, getCopyableAddButtonText(index + 1)))),
            React__namespace.createElement("div", null,
                React__namespace.createElement("button", { className: "is-size-6 ".concat(styles$4.addButton), onClick: onAdd, "aria-describedby": addButtonDescriptionId }, isCopyable
                    ? ADD_BUTTON_TEXT_WHEN_COPYABLE
                    : ADD_BUTTON_TEXT_WHEN_NOT_COPYABLE))))));
};

var ConfirmRepeatableElementTemplate = /** @class */ (function () {
    function ConfirmRepeatableElementTemplate() {
    }
    ConfirmRepeatableElementTemplate.prototype.get = function (elem) {
        return ConfirmRepeatableTemplate;
    };
    ConfirmRepeatableElementTemplate.prototype.getUnit = function (type) {
        return ConfirmRepeatableUnit;
    };
    return ConfirmRepeatableElementTemplate;
}());
var DefaultConfirmRepeatableTemplateRegistry = new ConfirmRepeatableElementTemplate();

var SectionForm = function (_a) {
    var sectionElem = _a.sectionElem, _b = _a.values, values = _b === void 0 ? {} : _b, InputElementRegistry = _a.InputElementRegistry, FieldTemplateRegistry = _a.FieldTemplateRegistry, RepeatableElementRegistry = _a.RepeatableElementRegistry;
    var formValues = values || {};
    return (React__namespace.createElement(React__namespace.Fragment, null, sectionElem.children.map(function (elem) {
        if (formSchema.isRepeatableElement(elem)) {
            return (React__namespace.createElement(Repeatable, { key: elem.id, config: elem, applyingRules: [], values: formValues[elem.id], errors: [], touched: [], disabled: true, onChange: function () { }, onFocus: function () { }, onBlur: function () { }, setFieldTouched: function () { }, setFieldValue: function () { }, setTouched: function () { }, RepeatableElementRegistry: RepeatableElementRegistry, InputElementRegistry: InputElementRegistry, FieldTemplateRegistry: FieldTemplateRegistry }));
        }
        if (formSchema.isInputElement(elem)) {
            var FieldTemplate = FieldTemplateRegistry.get(elem);
            var Input = InputElementRegistry.get(elem);
            return (React__namespace.createElement(FieldTemplate, { config: elem, key: elem.id },
                React__namespace.createElement(Input, { value: formValues[elem.id], config: elem, touched: false, error: undefined, onChange: console.log, onBlur: console.log, onFocus: console.log, setValue: console.log })));
        }
    })));
};
var PreviewFormGenerator = function (_a) {
    var schema = _a.schema, currentSection = _a.currentSection, values = _a.values, _b = _a.InputElementRegistry, InputElementRegistry = _b === void 0 ? DefaultInputTemplateRegistry : _b, _c = _a.FieldTemplateRegistry, FieldTemplateRegistry = _c === void 0 ? DefaultTemplateRegistry : _c, _d = _a.RepeatableElementRegistry, RepeatableElementRegistry = _d === void 0 ? DefaultRepeatableTemplateRegistry : _d;
    return (React__namespace.createElement(React__namespace.Fragment, null, schema.root.map(function (s, index) {
        if (!!currentSection && currentSection !== index) {
            return null;
        }
        return (React__namespace.createElement("div", { key: s.id, style: {
                marginBottom: "24px",
            } },
            React__namespace.createElement("p", { className: "title is-size-4", style: { marginBottom: "12px" } }, s.title),
            React__namespace.createElement(SectionForm, { values: values, sectionElem: s, InputElementRegistry: InputElementRegistry, FieldTemplateRegistry: FieldTemplateRegistry, RepeatableElementRegistry: RepeatableElementRegistry })));
    })));
};

// SectionTemplate から呼ばれることを想定したカスタムフック。
// 当該セクション内の入力要素に対してヘルパーテキストを提供するための props を返す。
var useHelperTextPropsMap = function () {
    var _a = useFormEventNotifier(), addObserver = _a.addObserver, removeObserver = _a.removeObserver;
    var _b = React__default["default"].useState({}), helperTextPropsMap = _b[0], setHelperTextPropsMap = _b[1];
    React__default["default"].useEffect(function () {
        var observerId = addObserver(function (event) {
            setHelperTextPropsMap(function (prev) {
                var next = tslib.__assign({}, prev);
                switch (event.name) {
                    case "POSTAL_CODE_SEARCH_BUTTON_SHOWN":
                        next[event.payload.postalCodeElementId] = {
                            text: grafferDesignKit.ADDRESS_AUTO_INPUT_INFO_TEXT,
                            descriptionId: formSchema.getPostalCodeHelperTextId(event.payload.postalCodeElementId),
                        };
                        next[event.payload.addressCompleteTarget] = {
                            text: grafferDesignKit.ASK_USER_TO_COMPLETE_ADDRESS_FORM_TEXT,
                        };
                        break;
                    case "POSTAL_CODE_SEARCH_BUTTON_HIDDEN":
                        delete next[event.payload.postalCodeElementId];
                        delete next[event.payload.addressCompleteTarget];
                        break;
                }
                return next;
            });
        });
        return function () {
            removeObserver(observerId);
        };
    }, [addObserver, removeObserver]);
    return helperTextPropsMap;
};

var SectionTemplate = function (props) {
    var section = props.section, _a = props.applyingRules, applyingRules = _a === void 0 ? [] : _a, disabled = props.disabled, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, InputTemplateRegistry = props.InputTemplateRegistry, FieldTemplateRegistry = props.FieldTemplateRegistry, RepeatableTemplateRegistry = props.RepeatableTemplateRegistry, SectionTemplateRegistry = props.SectionTemplateRegistry, FunctionTemplateRegistry = props.FunctionTemplateRegistry, FunctionFieldTemplateRegistry = props.FunctionFieldTemplateRegistry, StaticTemplateRegistry = props.StaticTemplateRegistry, StaticFieldTemplateRegistry = props.StaticFieldTemplateRegistry, setFieldValue = props.setFieldValue, setFieldTouched = props.setFieldTouched, setTouched = props.setTouched; props.autoComplete; var rests = tslib.__rest(props, ["section", "applyingRules", "disabled", "onBlur", "onChange", "onFocus", "InputTemplateRegistry", "FieldTemplateRegistry", "RepeatableTemplateRegistry", "SectionTemplateRegistry", "FunctionTemplateRegistry", "FunctionFieldTemplateRegistry", "StaticTemplateRegistry", "StaticFieldTemplateRegistry", "setFieldValue", "setFieldTouched", "setTouched", "autoComplete"]);
    var WrapperComponent = SectionTemplateRegistry.getSectionWrapper(section);
    var helperTextPropsMap = useHelperTextPropsMap();
    return (React__namespace.createElement(WrapperComponent, { section: section }, section.children.map(function (elem, _, sectionChildrenArr) {
        if (formSchema.isRepeatableElement(elem)) {
            var appliedElem = elem.applyRuleToParent(applyingRules);
            if (appliedElem.hidden) {
                return null;
            }
            var value = rests.values[elem.id];
            var error = rests.errors[elem.id];
            var touched = rests.touched[elem.id];
            return (React__namespace.createElement(Repeatable, { key: elem.id, disabled: disabled, config: appliedElem, applyingRules: applyingRules, values: value, errors: error, touched: touched, onChange: onChange, onFocus: onFocus, onBlur: onBlur, setFieldTouched: setFieldTouched, setFieldValue: setFieldValue, setTouched: function (updatedTouched, shouldValidate) {
                    var _a;
                    setTouched(tslib.__assign(tslib.__assign({}, rests.touched), (_a = {}, _a[elem.id] = updatedTouched, _a)), shouldValidate);
                }, RepeatableElementRegistry: RepeatableTemplateRegistry, InputElementRegistry: InputTemplateRegistry, FieldTemplateRegistry: FieldTemplateRegistry }));
        }
        if (formSchema.isInputElement(elem)) {
            var appliedElem = elem.applyRules(applyingRules);
            if (appliedElem.hidden) {
                return null;
            }
            return (React__namespace.createElement(InputElementTemplate, tslib.__assign({}, props, { key: appliedElem.id, sectionChildrenArr: sectionChildrenArr, elem: elem, appliedElem: appliedElem, helperTextProps: helperTextPropsMap[elem.id] })));
        }
        if (formSchema.isFunctionElement(elem)) {
            var appliedElem = elem.applyRules(applyingRules);
            if (appliedElem.hidden) {
                return null;
            }
            var FunctionTemplate = FunctionTemplateRegistry.get(elem);
            var FunctionFieldTemplate = FunctionFieldTemplateRegistry.get(elem);
            return (React__namespace.createElement(FunctionFieldTemplate, { key: appliedElem.id, config: appliedElem },
                React__namespace.createElement(FunctionTemplate, { config: appliedElem, disabled: disabled })));
        }
        if (formSchema.isStaticElement(elem)) {
            var appliedElem = elem.applyRules(applyingRules);
            if (appliedElem.hidden) {
                return null;
            }
            var StaticTemplate = StaticTemplateRegistry.get(elem);
            var StaticFieldTemplate = StaticFieldTemplateRegistry.get(elem);
            return (React__namespace.createElement(StaticFieldTemplate, { key: appliedElem.id, config: appliedElem },
                React__namespace.createElement(StaticTemplate, { config: appliedElem, disabled: disabled })));
        }
    })));
};
var InputElementTemplate = function (_a) {
    _a.section; var disabled = _a.disabled, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, InputTemplateRegistry = _a.InputTemplateRegistry, FieldTemplateRegistry = _a.FieldTemplateRegistry; _a.RepeatableTemplateRegistry; _a.SectionTemplateRegistry; _a.FunctionTemplateRegistry; _a.FunctionFieldTemplateRegistry; _a.StaticTemplateRegistry; _a.StaticFieldTemplateRegistry; var setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched; _a.setTouched; var autoComplete = _a.autoComplete, elem = _a.elem, appliedElem = _a.appliedElem; _a.sectionChildrenArr; var helperTextProps = _a.helperTextProps, rests = tslib.__rest(_a, ["section", "disabled", "onBlur", "onChange", "onFocus", "InputTemplateRegistry", "FieldTemplateRegistry", "RepeatableTemplateRegistry", "SectionTemplateRegistry", "FunctionTemplateRegistry", "FunctionFieldTemplateRegistry", "StaticTemplateRegistry", "StaticFieldTemplateRegistry", "setFieldValue", "setFieldTouched", "setTouched", "autoComplete", "elem", "appliedElem", "sectionChildrenArr", "helperTextProps"]);
    // 再描画されるときにフォーカスが外れてしまうので、useMemoを使用。
    var FieldTemplate = React.useMemo(function () { return FieldTemplateRegistry.get(elem); }, [FieldTemplateRegistry, elem]);
    var Input = InputTemplateRegistry.get(elem);
    var value = rests.values[elem.id];
    var error = rests.errors[elem.id];
    var touched = rests.touched[elem.id];
    var setValue = function (v) {
        setFieldTouched(elem.id, true, false);
        setFieldValue(elem.id, v, true);
    };
    return (React__namespace.createElement(FieldTemplate, { key: elem.id, config: appliedElem, error: error, touched: touched, disabled: disabled, helperTextProps: helperTextProps },
        React__namespace.createElement(Input, { config: appliedElem, value: value, onBlur: onBlur, onChange: onChange, onFocus: onFocus, error: error, touched: touched, setValue: setValue, disabled: disabled, autoComplete: autoComplete })));
};

var DefaultSectionWrapperTemplate = function (_a) {
    var section = _a.section, children = _a.children;
    return (React__namespace.createElement("div", { key: section.id, style: {
            marginBottom: "24px",
        } },
        React__namespace.createElement("h2", { className: "title is-size-2-desktop is-size-3-mobile", style: { marginBottom: "12px" } }, section.title),
        children));
};

var SectionTemplateRegistryImpl = /** @class */ (function () {
    function SectionTemplateRegistryImpl() {
        return;
    }
    SectionTemplateRegistryImpl.prototype.get = function (_elem) {
        return SectionTemplate;
    };
    SectionTemplateRegistryImpl.prototype.getSectionWrapper = function (_type) {
        return DefaultSectionWrapperTemplate;
    };
    return SectionTemplateRegistryImpl;
}());
var DefaultSectionTemplateRegistry = new SectionTemplateRegistryImpl();

var _a$1;
var ComponentTypeMap$1 = (_a$1 = {},
    _a$1[formSchema.FunctionTypes.CorporateSearch] = CorporateSearch,
    _a$1);

var FunctionTemplateRegistry = /** @class */ (function () {
    function FunctionTemplateRegistry() {
        this.componentMap = tslib.__assign({}, ComponentTypeMap$1);
    }
    FunctionTemplateRegistry.prototype.get = function (element) {
        // Matcher の型へ Generics を渡せないので、 any でキャストしてしまう。
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.componentMap[element.functionType];
    };
    return FunctionTemplateRegistry;
}());
var DefaultFunctionTemplateRegistry = new FunctionTemplateRegistry();

var css_248z$2 = ".component-module_description__ln8BY {\n  font: undefined;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n";
var styles$2 = {"description":"component-module_description__ln8BY"};
styleInject(css_248z$2);

var css_248z$1 = ".index-module_fontNormal__lSvH- {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.index-module_fontLarge__QiVMi {\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.index-module_markdownContent__h5YkT {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5em;\n  max-width: 100%;\n  width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  margin-top: 4px;\n  margin-bottom: 8px;\n}\n\n.index-module_markdownContent__h5YkT h1,\n.index-module_markdownContent__h5YkT h2,\n.index-module_markdownContent__h5YkT h3,\n.index-module_markdownContent__h5YkT a,\n.index-module_markdownContent__h5YkT ul,\n.index-module_markdownContent__h5YkT ol,\n.index-module_markdownContent__h5YkT p,\n.index-module_markdownContent__h5YkT p:not(:last-child),\n.index-module_markdownContent__h5YkT ol:not(:last-child),\n.index-module_markdownContent__h5YkT ul:not(:last-child),\n.index-module_markdownContent__h5YkT h3:not(:first-child) {\n  margin: 0;\n}\n\n.index-module_markdownContent__h5YkT p {\n  white-space: pre-wrap;\n}\n\n.index-module_markdownContent__h5YkT h2 {\n  color: #1d1c1a;\n  border-left: 4px solid #454ab8;\n  text-align: left;\n  padding-left: 0.75em;\n  font:\n    2em/1.5em Meiryo,\n    Arial,\n    system-ui,\n    sans-serif;\n}\n\n.index-module_markdownContent__h5YkT h3 {\n  color: #1d1c1a;\n  text-align: left;\n  font:\n    bold 1.5em/1.5em Meiryo,\n    Arial,\n    system-ui,\n    sans-serif;\n}\n\n.index-module_markdownContent__h5YkT ol {\n  list-style-type: decimal;\n}\n\n.index-module_markdownContent__h5YkT ul {\n  list-style-type: circle;\n}\n\n.index-module_markdownContent__h5YkT ol li,\n.index-module_markdownContent__h5YkT ul li {\n  margin-left: 1.5em;\n}\n\n.index-module_markdownContent__h5YkT ol li + li,\n.index-module_markdownContent__h5YkT ul li + li {\n  margin-top: 0.5em;\n}\n\n.index-module_markdownContent__h5YkT a {\n  font:\n    1em/1.25em Meiryo,\n    Arial,\n    system-ui,\n    sans-serif !important;\n  -webkit-text-decoration: underline #454ab8;\n          text-decoration: underline #454ab8;\n  padding: 0.25em 0.5em;\n}\n\n.index-module_markdownContent__h5YkT a:focus {\n  outline: 2px solid #454ab8;\n  border-radius: 8px;\n  background-color: transparent;\n}\n\n.index-module_markdownContent__h5YkT a svg {\n  width: 1.5em;\n}\n\n.index-module_markdownContent__h5YkT a:visited {\n  -webkit-text-decoration: underline #7b319a;\n          text-decoration: underline #7b319a;\n  color: #7b319a !important;\n}\n";
var styles$1 = {"fontNormal":"index-module_fontNormal__lSvH-","fontLarge":"index-module_fontLarge__QiVMi","markdownContent":"index-module_markdownContent__h5YkT"};
styleInject(css_248z$1);

var MarkdownStyleWrapper = function (_a) {
    var value = _a.value, _b = _a.fontSize, fontSize = _b === void 0 ? "normal" : _b, markdownProcessor = _a.markdownProcessor;
    return (React__namespace.createElement("div", { className: classNames__default["default"](styles$1.markdownContent, fontSize === "large" && styles$1.fontLarge, fontSize === "normal" && styles$1.fontNormal) },
        React__namespace.createElement(MarkdownErrorHandler, { value: value, markdownProcessor: markdownProcessor })));
};

var Description = function (_a) {
    var config = _a.config;
    var markdownProcessor = useMarkdownConfig().markdownProcessor;
    if (config.isMarkdown) {
        return (React__namespace.createElement("div", { className: "field" },
            React__namespace.createElement(MarkdownStyleWrapper, { fontSize: "large", value: config.text, markdownProcessor: markdownProcessor })));
    }
    return React__namespace.createElement("p", { className: styles$2.description }, config.text);
};

var css_248z = ".component-module_image-component__oF-4Y {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  /* TODO(twakino): implements */\n  /* サイズ調整、配置設定を検討する */\n}\n";
var styles = {"image-component":"component-module_image-component__oF-4Y"};
styleInject(css_248z);

var ImageComponent = function (_a) {
    var config = _a.config, disabled = _a.disabled;
    var imageRefkeyExchanger = useImageRefkeyExchanger();
    // 操作不能状態のとき、このコンポーネントを描画する意味はないので
    // 何も表示しない
    if (disabled) {
        return React__default["default"].createElement(React__default["default"].Fragment, null);
    }
    return (React__default["default"].createElement("div", { className: styles.imageContainer },
        React__default["default"].createElement("img", { className: styles.image, src: config.refKey
                ? imageRefkeyExchanger.refkeyToSrc(config.refKey)
                : undefined, loading: "lazy", alt: config.altText })));
};

var _a;
var ComponentTypeMap = (_a = {},
    _a[formSchema.StaticTypes.Description] = Description,
    _a[formSchema.StaticTypes.Image] = ImageComponent,
    _a);

var StaticTemplateRegistry = /** @class */ (function () {
    function StaticTemplateRegistry() {
        this.componentMap = tslib.__assign({}, ComponentTypeMap);
    }
    StaticTemplateRegistry.prototype.get = function (element) {
        // Matcher の型へ Generics を渡せないので、 any でキャストしてしまう。
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.componentMap[element.staticType];
    };
    return StaticTemplateRegistry;
}());
var DefaultStaticTemplateRegistry = new StaticTemplateRegistry();

/*
 * これは決断を遅延するための方法で、継続的に使用する想定ではない。
 * これ以上の実装を追加しようとするときになんらかのライブラリ（Styled-componentsを想定）を選定して置き換えること
 * プロジェクトの特性上、CSS in JSになることが濃厚
 */
var AddHeaderStyle = function () {
    var style = document.createElement("style");
    // Bulmaの他のラジオボタンやチェックボックスに影響してしまうので、`graffer-fg` (graffer-form-generater)というクラス名を必須にしておく
    var radioStyle = document.createTextNode("\n        .graffer-fg.radio {\n          position: relative;\n        }\n        .graffer-fg.radio input[type=\"radio\"]{\n          display: none;\n        }\n        .graffer-fg.radio input[type=\"radio\"] + .radio-icon {\n          position: relative;\n          padding-left: 1rem;\n        }\n        .graffer-fg.radio input[type=\"radio\"] + .radio-icon:before {\n          content: \"\";\n          display: block;\n          position: absolute;\n          top: 50%;\n          left: 0;\n          width: 1rem;\n          height: 1rem;\n          border: 1px solid #999;\n          border-radius: 50%;\n          transform: translateY(-50%);\n        }\n        .graffer-fg.radio input[type=\"radio\"]:checked + .radio-icon:before {\n          border-color: #36C03B;\n        }\n        .graffer-fg.radio input[type=\"radio\"]:checked + .radio-icon:after {\n          content: \"\";\n          display: block;\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          width: .5rem;\n          height: .5rem;\n          background-color: #36C03B;\n          border-radius: 50%;\n        }\n        \n        .graffer-fg.checkbox {\n          position: relative;\n        }\n        .graffer-fg.checkbox input[type=\"checkbox\"]{\n          display: none;\n        }\n        .graffer-fg.checkbox input[type=\"checkbox\"] + .checkbox-icon {\n          position: relative;\n          padding-left: 1rem;\n        }\n        .graffer-fg.checkbox input[type=\"checkbox\"] + .checkbox-icon:before {\n          content: \"\";\n          display: block;\n          position: absolute;\n          top: 50%;\n          left: 0;\n          width: 1rem;\n          height: 1rem;\n          border: 1px solid #999;\n          border-radius: 4px;\n          transform: translateY(-50%);\n        }\n        .graffer-fg.checkbox input[type=\"checkbox\"]:checked + .checkbox-icon:before {\n          border-color: #36C03B;\n        }\n        .graffer-fg.checkbox input[type=\"checkbox\"]:checked + .checkbox-icon:after {\n          content: \"\";\n          display: block;\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          width: .5rem;\n          height: .5rem;\n          background-color: #36C03B;\n          border-radius: 4px;\n        }\n    ");
    style.type = "text/css";
    style.appendChild(radioStyle);
    document.head.appendChild(style);
};

var useUpdateConfirmContext = function (confirmContext) {
    // 最後に「編集」もしくは「完了する」ボタンを押したフィールドのIDを保持。（フォーカス処理に使用）
    var _a = React.useState(""), lastClickedButtonFieldId = _a[0], setLastClickedButtonFieldId = _a[1];
    var onEdit = React.useCallback(function (elem, edit, isCalledByButton) {
        if (isCalledByButton) {
            //「編集」もしくは「完了する」ボタンを押した際に、onEditが呼び出された場合。
            setLastClickedButtonFieldId(elem.formFieldId);
        }
        if (confirmContext === null || confirmContext === void 0 ? void 0 : confirmContext.onEdit) {
            confirmContext.onEdit(elem, edit);
        }
    }, [confirmContext]);
    // フォーカス処理に使用する情報を追加・上書き。
    var newConfirmContext = React.useMemo(function () {
        return tslib.__assign(tslib.__assign({}, confirmContext), { onEdit: onEdit, lastClickedButtonFieldId: lastClickedButtonFieldId });
    }, [confirmContext, onEdit, lastClickedButtonFieldId]);
    return {
        newConfirmContext: newConfirmContext,
    };
};

var FormikCompatibleGenerator = function (_a) {
    var schema = _a.schema, currentSection = _a.currentSection, _b = _a.InputTemplateRegistry, InputTemplateRegistry = _b === void 0 ? DefaultInputTemplateRegistry : _b, _c = _a.FieldTemplateRegistry, FieldTemplateRegistry = _c === void 0 ? DefaultTemplateRegistry : _c, _d = _a.RepeatableTemplateRegistry, RepeatableTemplateRegistry = _d === void 0 ? DefaultRepeatableTemplateRegistry : _d, _e = _a.SectionTemplateRegistry, SectionTemplateRegistry = _e === void 0 ? DefaultSectionTemplateRegistry : _e, _f = _a.FunctionTemplateRegistry, FunctionTemplateRegistry = _f === void 0 ? DefaultFunctionTemplateRegistry : _f, _g = _a.FunctionFieldTemplateRegistry, FunctionFieldTemplateRegistry = _g === void 0 ? DefaultFunctionFieldTemplateRegistry : _g, _h = _a.StaticTemplateRegistry, StaticTemplateRegistry = _h === void 0 ? DefaultStaticTemplateRegistry : _h, _j = _a.StaticFieldTemplateRegistry, StaticFieldTemplateRegistry = _j === void 0 ? DefaultStaticFieldTemplateRegistry : _j, applyingRules = _a.applyingRules, disabled = _a.disabled, formikBag = tslib.__rest(_a, ["schema", "currentSection", "InputTemplateRegistry", "FieldTemplateRegistry", "RepeatableTemplateRegistry", "SectionTemplateRegistry", "FunctionTemplateRegistry", "FunctionFieldTemplateRegistry", "StaticTemplateRegistry", "StaticFieldTemplateRegistry", "applyingRules", "disabled"]);
    var onChange = formikBag.handleChange;
    var onBlur = formikBag.handleBlur;
    var onFocus = formikBag.handleFocus;
    var errors = formikBag.errors || {};
    var values = formikBag.values;
    return (React__namespace.createElement(React__namespace.Fragment, null, schema.root.map(function (s, index) {
        if (currentSection !== undefined && currentSection !== index) {
            return null;
        }
        var SectTemplate = SectionTemplateRegistry.get(s);
        return (React__namespace.createElement(SectTemplate, { section: s, key: s.id, applyingRules: applyingRules, values: values, errors: errors, onFocus: onFocus, onBlur: onBlur, onChange: onChange, disabled: disabled, touched: formikBag.touched, setTouched: formikBag.setTouched, setFieldValue: formikBag.setFieldValue, setFieldTouched: formikBag.setFieldTouched, SectionTemplateRegistry: SectionTemplateRegistry, InputTemplateRegistry: InputTemplateRegistry, FieldTemplateRegistry: FieldTemplateRegistry, RepeatableTemplateRegistry: RepeatableTemplateRegistry, FunctionTemplateRegistry: FunctionTemplateRegistry, FunctionFieldTemplateRegistry: FunctionFieldTemplateRegistry, StaticTemplateRegistry: StaticTemplateRegistry, StaticFieldTemplateRegistry: StaticFieldTemplateRegistry }));
    })));
};
/**
 * Formikを排除して内部構造を実装したFormGenerator
 *
 * caveat: 検証が十分に済んでいないため、検証が十分に完了するまで本番では使わないこと
 */
var FormGeneratorV2 = function (props) {
    var values = props.values, confirmContext = props.confirmContext;
    var newConfirmContext = useUpdateConfirmContext(confirmContext).newConfirmContext;
    var formSchema = props.formSchema;
    // ここでheadに埋め込むstyleの定義
    React.useEffect(function () {
        AddHeaderStyle();
    }, []);
    var rules = formSchema.filterApplyingRule(values);
    return (React__namespace.createElement(FormContext.Provider, { value: {
            refKeyContext: props.refkeyContext || {},
            confirmContext: newConfirmContext,
            modificationContext: props.modificationContext || {},
            submissionContext: props.submissionContext,
            enableRepeatableExpand: props.enableRepeatableExpand,
            externalServiceUrlConfig: props.externalServiceUrlConfig,
            markdownConfig: props.markdownConfig,
        } },
        React__namespace.createElement(FormEventNotifierContextProvider, null,
            React__namespace.createElement(FormFieldInteractionContextProvider, { setFieldTouched: props.setFieldTouched, setFieldValue: props.setFieldValue },
                React__namespace.createElement(FormikCompatibleGenerator, { schema: formSchema, currentSection: props.currentSection, applyingRules: rules, errors: props.errors, values: props.values, touched: props.touched, disabled: props.disable, handleChange: props.handleChange, handleBlur: props.handleBlur, handleFocus: function (e) {
                        if (props.handleFocus) {
                            props.handleFocus(e);
                        }
                    }, setFieldTouched: props.setFieldTouched, setFieldValue: props.setFieldValue, setTouched: props.setTouched, InputTemplateRegistry: props.InputElementRegistry, FieldTemplateRegistry: props.FieldTemplateRegistry, SectionTemplateRegistry: props.SectionTemplateRegistry, RepeatableTemplateRegistry: props.RepeatableTemplateRegistry, FunctionTemplateRegistry: props.FunctionTemplateRegistry, FunctionFieldTemplateRegistry: props.FunctionFieldTemplateRegistry, StaticTemplateRegistry: props.StaticTemplateRegistry, StaticFieldTemplateRegistry: props.StaticFieldTemplateRegistry })))));
};

var BaseFormGeneratorViewModel = /** @class */ (function () {
    function BaseFormGeneratorViewModel(formSchema, values, errors, sectionErrors, touched, refKeyRegistry, formSubmissionContext) {
        this.formSchema = formSchema;
        this.values = values;
        this.errors = errors;
        this.sectionErrors = sectionErrors;
        this.touched = touched;
        this.refKeyRegistry = refKeyRegistry;
        this.formSubmissionContext = formSubmissionContext;
    }
    BaseFormGeneratorViewModel.prototype.setOnUpdated = function (onUpdated) {
        this.onUpdated = onUpdated;
    };
    BaseFormGeneratorViewModel.prototype.handleBlur = function (e) {
        var field = this.parseFieldId(e.target, true);
        if (!field) {
            // time-range inputなど入力フォームと値が対応していないものはname or idが渡ってこないケースがある
            // V2に移行したタイミングでコンポーネント側を修正するが、現時点ではv1側に影響を出さないためにハンドリング側で対応する
            return;
        }
        this.setFieldTouched(this.parseFieldId(e.target), true, true);
    };
    BaseFormGeneratorViewModel.prototype.handleChange = function (e) {
        var value = e.target.value;
        this.setFieldValue(this.parseFieldId(e.target), value, true);
    };
    BaseFormGeneratorViewModel.prototype.handleFocus = function (e) {
        // noop
    };
    BaseFormGeneratorViewModel.prototype.setFieldValue = function (field, value, shouldValidate) {
        this.values = this.formSchema.cleanHidden(tslib.__assign({}, ___namespace.set(this.values, field, value)));
        var _a = this.formSchema.getFormulaResultValuesAndTouched(this.values, this.touched), values = _a.values, touched = _a.touched;
        this.values = values;
        this.touched = touched;
        if (shouldValidate) {
            this.runValidation();
        }
        this.onUpdated(this.getProps());
    };
    BaseFormGeneratorViewModel.prototype.setFieldTouched = function (field, isTouched, shouldValidate) {
        this.touched = tslib.__assign({}, ___namespace.set(this.touched, field, isTouched));
        if (shouldValidate) {
            this.runValidation();
        }
        this.onUpdated(this.getProps());
    };
    BaseFormGeneratorViewModel.prototype.setTouched = function (touched, shouldValidate) {
        this.touched = tslib.__assign({}, touched);
        if (shouldValidate) {
            this.runValidation();
        }
        this.onUpdated(this.getProps());
    };
    BaseFormGeneratorViewModel.prototype.runValidation = function () {
        this.sectionErrors = this.formSchema.validateSections(this.values, this.refKeyRegistry(), {
            formSubmissionDate: this.formSubmissionContext.submissionDate,
        });
        this.errors = this.sectionErrors.reduce(function (pv, cv) { return (tslib.__assign(tslib.__assign({}, pv), cv)); }, {});
    };
    BaseFormGeneratorViewModel.prototype.parseFieldId = function (target, ignoreMissing) {
        var name = target.name, id = target.id;
        var formFieldId = name ? name : id;
        if (!formFieldId && !ignoreMissing) {
            throw new Error("missing formFieldId ".concat(formFieldId));
        }
        return formFieldId;
    };
    return BaseFormGeneratorViewModel;
}());
var FormGeneratorViewModel = /** @class */ (function (_super) {
    tslib.__extends(FormGeneratorViewModel, _super);
    function FormGeneratorViewModel(formSchema, values, errors, sectionErrors, touched, refKeyRegistry, formSubmissionContext) {
        var _this = _super.call(this, formSchema, values, errors, sectionErrors, touched, refKeyRegistry, formSubmissionContext) || this;
        _this.formSchema = formSchema;
        _this.values = values;
        _this.errors = errors;
        _this.sectionErrors = sectionErrors;
        _this.touched = touched;
        _this.refKeyRegistry = refKeyRegistry;
        _this.formSubmissionContext = formSubmissionContext;
        return _this;
    }
    FormGeneratorViewModel.prototype.getProps = function () {
        return {
            values: this.values,
            formSchema: this.formSchema,
            errors: this.errors,
            sectionErrors: this.sectionErrors,
            touched: this.touched,
            handleChange: this.handleChange.bind(this),
            handleBlur: this.handleBlur.bind(this),
            handleFocus: this.handleFocus.bind(this),
            setFieldValue: this.setFieldValue.bind(this),
            setFieldTouched: this.setFieldTouched.bind(this),
            setTouched: this.setTouched.bind(this),
        };
    };
    return FormGeneratorViewModel;
}(BaseFormGeneratorViewModel));
var useFormGenViewModel = function (args) {
    var viewModel = new FormGeneratorViewModel(args.formSchema, args.values, {}, [], {}, args.refKeyRegistry || (function () { return ({}); }), args.formSubmissionContext);
    var _a = React.useState(viewModel.getProps()), state = _a[0], setState = _a[1];
    viewModel.setOnUpdated(function (props) {
        setState(props);
    });
    return tslib.__assign({}, state);
};

exports.BaseFormGeneratorViewModel = BaseFormGeneratorViewModel;
exports.BulmaFieldTemplate = Field;
exports.ConfirmFieldTemplate = ConfirmFieldTemplate;
exports.ConfirmFieldTemplateRegistry = ConfirmFieldTemplateRegistry;
exports.ConfirmFunctionFieldTemplateRegistry = ConfirmFunctionFieldTemplateRegistry;
exports.ConfirmInputRegistry = ConfirmInputRegistry;
exports.ConfirmStaticFieldTemplateRegistry = ConfirmStaticFieldTemplateRegistry;
exports.DefaultConfirmFieldTemplateRegistry = DefaultConfirmFieldTemplateRegistry;
exports.DefaultConfirmFunctionFieldTemplateRegistry = DefaultConfirmFunctionFieldTemplateRegistry;
exports.DefaultConfirmInputTemplateRegistry = DefaultConfirmInputTemplateRegistry;
exports.DefaultConfirmRepeatableTemplateRegistry = DefaultConfirmRepeatableTemplateRegistry;
exports.DefaultConfirmStaticFieldTemplateRegistry = DefaultConfirmStaticFieldTemplateRegistry;
exports.DefaultFunctionFieldTemplateRegistry = DefaultFunctionFieldTemplateRegistry;
exports.DefaultFunctionTemplateRegistry = DefaultFunctionTemplateRegistry;
exports.DefaultInputTemplateRegistry = DefaultInputTemplateRegistry;
exports.DefaultRepeatableTemplateRegistry = DefaultRepeatableTemplateRegistry;
exports.DefaultSectionTemplateRegistry = DefaultSectionTemplateRegistry;
exports.DefaultStaticFieldTemplateRegistry = DefaultStaticFieldTemplateRegistry;
exports.DefaultStaticTemplateRegistry = DefaultStaticTemplateRegistry;
exports.DefaultTemplateRegistry = DefaultTemplateRegistry;
exports.FormContext = FormContext;
exports.FormGeneratorV2 = FormGeneratorV2;
exports.FormGeneratorViewModel = FormGeneratorViewModel;
exports.FunctionFieldTemplateRegistry = FunctionFieldTemplateRegistry;
exports.MarkdownStyleWrapper = MarkdownStyleWrapper;
exports.PreviewFormGenerator = PreviewFormGenerator;
exports.StaticFieldTemplateRegistry = StaticFieldTemplateRegistry;
exports.allTagNames = allTagNames;
exports.defaultFormSubmissionContext = defaultFormSubmissionContext;
exports.defaultMarkdownConfig = defaultMarkdownConfig;
exports.formatMynumberValue = formatMynumberValue;
exports.grafferSchemasSuportTagNames = grafferSchemasSuportTagNames;
exports.useExternalServiceUrlConfig = useExternalServiceUrlConfig;
exports.useFileRefKeyExchanger = useFileRefKeyExchanger;
exports.useFileRefKeyExchangerIfProvided = useFileRefKeyExchangerIfProvided;
exports.useFormGenViewModel = useFormGenViewModel;
exports.useFormSubmissionContext = useFormSubmissionContext;
exports.useHelperTextPropsMap = useHelperTextPropsMap;
exports.useImageRefkeyExchanger = useImageRefkeyExchanger;
exports.useMarkdownConfig = useMarkdownConfig;
exports.useMyNumberRefKeyExchanger = useMyNumberRefKeyExchanger;
exports.useMyNumberRefKeyExchangerIfProvided = useMyNumberRefKeyExchangerIfProvided;
exports.useRepeatableExpand = useRepeatableExpand;
